const CONSTANTS = {
  PRODUCT_DATE_FORMAT: "YYYY-MM-DD hh:mm:ss.SSS",
  DEFAULT_SHOPPING_CART_NAME: "default",
  DEFAULT_MAX_SHOPPING_CARTS: 2
};

class ActionQueue {
  constructor() {
    this.queue = [];
  }
  get length() {
    return this.queue.length;
  }
  enqueue(newItem) {
    this.queue.push(newItem);
  }
  dequeue() {
    return this.queue.shift();
  }
}

class EventLoop {
  constructor() {
    this.running = false;
  }
  async run() {
    const { queue } = getState();
    const next = queue.dequeue();
    if (!next) {
      this.running = false;
      return;
    }
    return await next();
  }
  get isRunning() {
    return this.running;
  }
  async start() {
    this.running = true;
    while (this.running) {
      await this.run();
    }
  }
}

var __defProp$k = Object.defineProperty;
var __getOwnPropSymbols$k = Object.getOwnPropertySymbols;
var __hasOwnProp$k = Object.prototype.hasOwnProperty;
var __propIsEnum$k = Object.prototype.propertyIsEnumerable;
var __defNormalProp$k = (obj, key, value) => key in obj ? __defProp$k(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$k = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$k.call(b, prop))
      __defNormalProp$k(a, prop, b[prop]);
  if (__getOwnPropSymbols$k)
    for (var prop of __getOwnPropSymbols$k(b)) {
      if (__propIsEnum$k.call(b, prop))
        __defNormalProp$k(a, prop, b[prop]);
    }
  return a;
};
const { DEFAULT_SHOPPING_CART_NAME: DEFAULT_SHOPPING_CART_NAME$2, DEFAULT_MAX_SHOPPING_CARTS } = CONSTANTS;
const initialState = {
  artisnApp: void 0,
  accountId: void 0,
  customerId: void 0,
  activeShoppingCart: DEFAULT_SHOPPING_CART_NAME$2,
  maxShoppingCarts: DEFAULT_MAX_SHOPPING_CARTS,
  wallets: {},
  anonymous: false,
  initialized: false,
  queue: new ActionQueue(),
  eventLoop: new EventLoop(),
  debug: false
};
Object.freeze(initialState);
let state = __spreadValues$k({}, initialState);
Object.seal(state);
const setState = (overrides) => {
  state = __spreadValues$k(__spreadValues$k({}, state), overrides);
};
const getState = () => {
  return __spreadValues$k({}, state);
};

var __defProp$j = Object.defineProperty;
var __defProps$e = Object.defineProperties;
var __getOwnPropDescs$e = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$j = Object.getOwnPropertySymbols;
var __hasOwnProp$j = Object.prototype.hasOwnProperty;
var __propIsEnum$j = Object.prototype.propertyIsEnumerable;
var __defNormalProp$j = (obj, key, value) => key in obj ? __defProp$j(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$j = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$j.call(b, prop))
      __defNormalProp$j(a, prop, b[prop]);
  if (__getOwnPropSymbols$j)
    for (var prop of __getOwnPropSymbols$j(b)) {
      if (__propIsEnum$j.call(b, prop))
        __defNormalProp$j(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$e = (a, b) => __defProps$e(a, __getOwnPropDescs$e(b));
const sortByField = (field, a, b) => {
  const idA = a[field];
  const idB = b[field];
  if (idA > idB) {
    return 1;
  } else if (idB > idA) {
    return -1;
  } else {
    return 0;
  }
};
const sortByProductId = (a, b) => {
  return sortByField("productId", a, b);
};
const sortByQuestionId = (a, b) => {
  return sortByField("questionId", a, b);
};
const logError = (message) => {
  if (process.env.NODE_ENV === "production") {
    console.error(message);
  } else {
    throw new Error(message);
  }
};
const logDebug = (message) => {
  const { debug } = getState();
  if (!debug)
    return;
  console.warn(message);
};
const reuseGlobalConfig = (config) => {
  const { debug: configDebug } = config != null ? config : {};
  const { store: configStore } = config != null ? config : {};
  const { accountId: configAccountId } = config != null ? config : {};
  const { anonymous: configAnonymous } = config != null ? config : {};
  const { customerId: configCustomerId } = config != null ? config : {};
  const { shoppingCartName: configCartName } = config != null ? config : {};
  const { maxShoppingCarts: configMaxShoppingCarts } = config != null ? config : {};
  const { accountId: globalAccountId } = getState();
  const { customerId: globalCustomerId } = getState();
  const { store: globalStore, anonymous: globalAnonymous } = getState();
  const { activeShoppingCart: globalCartName } = getState();
  const { maxShoppingCarts: globalMaxShoppingCarts } = getState();
  const { debug: globalDebug } = getState();
  const accountId = configAccountId != null ? configAccountId : globalAccountId;
  const customerId = configCustomerId != null ? configCustomerId : globalCustomerId;
  const prunedConfigStore = configStore ? __spreadProps$e(__spreadValues$j({}, configStore), { polygons: null }) : void 0;
  const store = prunedConfigStore != null ? prunedConfigStore : globalStore;
  const shoppingCartName = configCartName != null ? configCartName : globalCartName;
  const maxShoppingCarts = configMaxShoppingCarts != null ? configMaxShoppingCarts : globalMaxShoppingCarts;
  const anonymous = configAnonymous != null ? configAnonymous : globalAnonymous;
  const debug = configDebug != null ? configDebug : globalDebug;
  return __spreadProps$e(__spreadValues$j({}, config), {
    shoppingCartName,
    customerId,
    store,
    accountId,
    anonymous,
    maxShoppingCarts,
    debug
  });
};

var __defProp$i = Object.defineProperty;
var __defProps$d = Object.defineProperties;
var __getOwnPropDescs$d = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$i = Object.getOwnPropertySymbols;
var __hasOwnProp$i = Object.prototype.hasOwnProperty;
var __propIsEnum$i = Object.prototype.propertyIsEnumerable;
var __defNormalProp$i = (obj, key, value) => key in obj ? __defProp$i(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$i = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$i.call(b, prop))
      __defNormalProp$i(a, prop, b[prop]);
  if (__getOwnPropSymbols$i)
    for (var prop of __getOwnPropSymbols$i(b)) {
      if (__propIsEnum$i.call(b, prop))
        __defNormalProp$i(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$d = (a, b) => __defProps$d(a, __getOwnPropDescs$d(b));
const { DEFAULT_SHOPPING_CART_NAME: DEFAULT_SHOPPING_CART_NAME$1 } = CONSTANTS;
const initShoppingCart = (artisnApp, config = {}) => {
  const { initialized } = getState();
  if (initialized) {
    logDebug(`initShoppingCart has been called more than once.
      This behavior will very likely result in unexpected outcomes so its
      call was skipped. Please make sure initShoppingCart is only called once`);
    return;
  }
  const { shoppingCartName } = config;
  setState(__spreadProps$d(__spreadValues$i({
    artisnApp
  }, config), {
    activeShoppingCart: shoppingCartName != null ? shoppingCartName : DEFAULT_SHOPPING_CART_NAME$1
  }));
  const isServer = typeof window === "undefined";
  if (!isServer)
    setState({ initialized: true });
};
const closeShoppingCart = () => {
  setState(__spreadValues$i({}, initialState));
};

const checkArtisnAppProvided = (message = "") => {
  const { artisnApp } = getState();
  if (!artisnApp) {
    throw new Error(`Artisn app must be provided, you probably forgot to initialize the shopping cart. Please make sure initShoppingCart has been called beforehand. ${message}`);
  }
};

const checkAccountId = (accountId, message = "") => {
  const { accountId: globalAccountId } = getState();
  if (typeof accountId === "undefined" && typeof globalAccountId === "undefined") {
    throw new Error(`AccountId must be defined. Either provide a global accountId or at the function call level. ${message}`);
  }
};
const checkCustomerId = (customerId, message = "") => {
  const { customerId: globalCustomerId } = getState();
  if (typeof customerId === "undefined" && typeof globalCustomerId === "undefined") {
    throw new Error(`CustomerId must be defined. Either provide a global customerId or at the function call level. ${message}`);
  }
};
const checkStoreId = (store, message = "") => {
  const { store: globalStore } = getState();
  if (typeof store === "undefined" && typeof globalStore === "undefined") {
    throw new Error(`Store must be defined. Either provide a global store or at the function call level. ${message}`);
  }
};
const checkApiURL = (apiURL, message = "") => {
  const { apiURL: globalApiURL } = getState().artisnApp;
  if (typeof apiURL === "undefined" && typeof globalApiURL === "undefined") {
    throw new Error(`ApiURL must be defined. Either provide a global ApiURL or at the function call level. ${message}`);
  }
};
const checkMinimumConfigProvided = (config = {}) => {
  const { accountId, customerId } = config;
  checkAccountId(accountId);
  checkCustomerId(customerId);
};
const checkBenefitConfigProvided = (wallets, cartName, config) => {
  const { benefitId } = config != null ? config : {};
  const activeWallet = wallets[cartName];
  const benefits = activeWallet == null ? void 0 : activeWallet.benefits;
  checkBenefitId(benefitId);
  if (!activeWallet || !benefits) {
    return `No benefits wallet available for ${cartName}, you probably forgot to call listenBenefitsWallet beforehand.`;
  }
};
const checkBenefitId = (benefitId) => {
  if (typeof benefitId !== "undefined")
    return;
  throw new Error(`BenefitId must be defined. Provide it at the function call level.`);
};
const checkVendorId = (vendorId, message = "") => {
  if (typeof vendorId === "undefined") {
    throw new Error(`VendorId must be defined. Provide a global vendorId at the function call level. ${message}`);
  }
};
const checkMinimumFetchWalletConfigProvided = (config) => {
  const { customerId } = config != null ? config : {};
  checkCustomerId(customerId);
};
const checkPlatform = (platform, message = "") => {
  const { artisnApp } = getState();
  const { settings } = artisnApp;
  const { platform: globalPlatform } = settings;
  if (typeof platform === "undefined" && typeof globalPlatform === "undefined") {
    throw new Error(`Platform must be defined. Either provide a global Platform in the artisn object or at the function call level. ${message}`);
  }
};
const checkCommonHeaders = (headers) => {
  const { Platform, account } = headers != null ? headers : {};
  checkPlatform(Platform);
  let selectedAccount = parseInt(account != null ? account : "", 10);
  if (isNaN(selectedAccount))
    selectedAccount = void 0;
  checkAccountId(selectedAccount);
};
const checkStoreCouponDetailConfig = (config, message = "") => {
  const { countryId, couponId } = config;
  if (typeof countryId === "undefined" || typeof couponId === "undefined") {
    throw new Error(`Country id or coupon id must be defined. Provide those params at the function call level. ${message}`);
  }
};

var __defProp$h = Object.defineProperty;
var __getOwnPropSymbols$h = Object.getOwnPropertySymbols;
var __hasOwnProp$h = Object.prototype.hasOwnProperty;
var __propIsEnum$h = Object.prototype.propertyIsEnumerable;
var __defNormalProp$h = (obj, key, value) => key in obj ? __defProp$h(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$h = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$h.call(b, prop))
      __defNormalProp$h(a, prop, b[prop]);
  if (__getOwnPropSymbols$h)
    for (var prop of __getOwnPropSymbols$h(b)) {
      if (__propIsEnum$h.call(b, prop))
        __defNormalProp$h(a, prop, b[prop]);
    }
  return a;
};
const getStore = (storeData, stores) => {
  const { storeId } = storeData != null ? storeData : {};
  return __spreadValues$h(__spreadValues$h({}, storeData), stores[storeId]);
};
const checkInit = () => getState().initialized;
const cleanShoppingCart = (shoppingCart, product) => {
  const { benefits } = shoppingCart;
  if (!(benefits == null ? void 0 : benefits.length))
    return shoppingCart;
  const benefit = benefits.find((benefit2) => {
    if (!product)
      return true;
    const { type } = benefit2;
    if (type !== "PRODUCT")
      return void 0;
    if (!Array.isArray(benefit2.award))
      return void 0;
    return benefit2.award.find((award) => award.productId.toString() === product.productId);
  });
  if (!benefit)
    return shoppingCart;
  delete shoppingCart.benefits;
  delete shoppingCart.benefitsHash;
  return shoppingCart;
};

const getShoppingCartNodes = async (config = {}) => {
  var _a, _b;
  const reusedConfig = reuseGlobalConfig(config);
  const { artisnApp } = getState();
  const { accountId, customerId, anonymous } = reusedConfig;
  checkArtisnAppProvided();
  checkMinimumConfigProvided(reusedConfig);
  const path = anonymous ? "anonymousShoppingCartByUser" : "shoppingCartByUser";
  const db = artisnApp == null ? void 0 : artisnApp.__internals__.firestore();
  const cartsCollection = await ((_b = (_a = db == null ? void 0 : db.collection(path)) == null ? void 0 : _a.doc(String(customerId))) == null ? void 0 : _b.collection(String(accountId)));
  return cartsCollection;
};
const getShoppingCartNode = async (config) => {
  const { shoppingCartName } = reuseGlobalConfig(config);
  const cartsCollection = await getShoppingCartNodes(config);
  if (!cartsCollection || !checkInit())
    return;
  const newestCart = await cartsCollection.where("name", "==", shoppingCartName).get().then((userCarts) => {
    return userCarts.docs[0];
  });
  return newestCart;
};
const getShoppingCart = async (config) => {
  return new Promise((resolve, reject) => {
    const action = async () => {
      try {
        const { shoppingCartName } = reuseGlobalConfig(config);
        const shoppingCartNode = await getShoppingCartNode(config);
        if (!shoppingCartNode || !checkInit()) {
          resolve(null);
          return null;
        }
        setState({ activeShoppingCart: shoppingCartName });
        const shoppingCart = shoppingCartNode.data();
        resolve(shoppingCart);
        return shoppingCart;
      } catch (e) {
        reject(e);
        return null;
      }
    };
    const { eventLoop, queue } = getState();
    queue.enqueue(action);
    if (!eventLoop.isRunning)
      eventLoop.start();
  });
};
const listenShoppingCart = async (onSnapshot, config = {}) => {
  const { shoppingCartName } = reuseGlobalConfig(config);
  const shoppingCartDocs = await getShoppingCartNodes(config);
  if (!shoppingCartDocs || !checkInit()) {
    return () => {
    };
  }
  setState({ activeShoppingCart: shoppingCartName });
  return shoppingCartDocs.where("name", "==", shoppingCartName).onSnapshot(async (snapshot) => {
    var _a;
    if (!((_a = snapshot == null ? void 0 : snapshot.docs) == null ? void 0 : _a[0])) {
      logDebug(`Failed to fetch a shopping cart with name ${shoppingCartName} because there wasn't any.`);
      return onSnapshot(void 0);
    }
    const shoppingCartData = await snapshot.docs[0].data();
    return onSnapshot(shoppingCartData);
  });
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var dayjs_min = {exports: {}};

(function (module, exports) {
!function(t,e){module.exports=e();}(commonjsGlobal,(function(){var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",f="month",h="quarter",c="year",d="date",$="Invalid Date",l=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_")},m=function(t,e,n){var r=String(t);return !r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},g={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return (e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return -t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,f),s=n-i<0,u=e.clone().add(r+(s?-1:1),f);return +(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return {M:f,y:c,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:h}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},D="en",v={};v[D]=M;var p=function(t){return t instanceof _},S=function(t,e,n){var r;if(!t)return D;if("string"==typeof t)v[t]&&(r=t),e&&(v[t]=e,r=t);else {var i=t.name;v[i]=t,r=i;}return !n&&r&&(D=r),r||!n&&D},w=function(t,e){if(p(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new _(n)},O=g;O.l=S,O.i=p,O.w=function(t,e){return w(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var _=function(){function M(t){this.$L=S(t.locale,null,!0),this.parse(t);}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(O.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match(l);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.$x=t.x||{},this.init();},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds();},m.$utils=function(){return O},m.isValid=function(){return !(this.$d.toString()===$)},m.isSame=function(t,e){var n=w(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return w(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<w(t)},m.$g=function(t,e,n){return O.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!O.u(e)||e,h=O.p(t),$=function(t,e){var i=O.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},l=function(t,e){return O.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,g="set"+(this.$u?"UTC":"");switch(h){case c:return r?$(1,0):$(31,11);case f:return r?$(1,M):$(0,M+1);case o:var D=this.$locale().weekStart||0,v=(y<D?y+7:y)-D;return $(r?m-v:m+(6-v),M);case a:case d:return l(g+"Hours",0);case u:return l(g+"Minutes",1);case s:return l(g+"Seconds",2);case i:return l(g+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=O.p(t),h="set"+(this.$u?"UTC":""),$=(n={},n[a]=h+"Date",n[d]=h+"Date",n[f]=h+"Month",n[c]=h+"FullYear",n[u]=h+"Hours",n[s]=h+"Minutes",n[i]=h+"Seconds",n[r]=h+"Milliseconds",n)[o],l=o===a?this.$D+(e-this.$W):e;if(o===f||o===c){var y=this.clone().set(d,1);y.$d[$](l),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d;}else $&&this.$d[$](l);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[O.p(t)]()},m.add=function(r,h){var d,$=this;r=Number(r);var l=O.p(h),y=function(t){var e=w($);return O.w(e.date(e.date()+Math.round(t*r)),$)};if(l===f)return this.set(f,this.$M+r);if(l===c)return this.set(c,this.$y+r);if(l===a)return y(1);if(l===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[l]||1,m=this.$d.getTime()+r*M;return O.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||$;var r=t||"YYYY-MM-DDTHH:mm:ssZ",i=O.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,f=n.months,h=function(t,n,i,s){return t&&(t[n]||t(e,r))||i[n].substr(0,s)},c=function(t){return O.s(s%12||12,t,"0")},d=n.meridiem||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r},l={YY:String(this.$y).slice(-2),YYYY:this.$y,M:a+1,MM:O.s(a+1,2,"0"),MMM:h(n.monthsShort,a,f,3),MMMM:h(f,a),D:this.$D,DD:O.s(this.$D,2,"0"),d:String(this.$W),dd:h(n.weekdaysMin,this.$W,o,2),ddd:h(n.weekdaysShort,this.$W,o,3),dddd:o[this.$W],H:String(s),HH:O.s(s,2,"0"),h:c(1),hh:c(2),a:d(s,u,!0),A:d(s,u,!1),m:String(u),mm:O.s(u,2,"0"),s:String(this.$s),ss:O.s(this.$s,2,"0"),SSS:O.s(this.$ms,3,"0"),Z:i};return r.replace(y,(function(t,e){return e||l[t]||i.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,$){var l,y=O.p(d),M=w(r),m=(M.utcOffset()-this.utcOffset())*e,g=this-M,D=O.m(this,M);return D=(l={},l[c]=D/12,l[f]=D,l[h]=D/3,l[o]=(g-m)/6048e5,l[a]=(g-m)/864e5,l[u]=g/n,l[s]=g/e,l[i]=g/t,l)[y]||g,$?D:O.a(D)},m.daysInMonth=function(){return this.endOf(f).$D},m.$locale=function(){return v[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=S(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return O.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),b=_.prototype;return w.prototype=b,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",f],["$y",c],["$D",d]].forEach((function(t){b[t[1]]=function(e){return this.$g(e,t[0],t[1])};})),w.extend=function(t,e){return t.$i||(t(e,_,w),t.$i=!0),w},w.locale=S,w.isDayjs=p,w.unix=function(t){return w(1e3*t)},w.en=v[D],w.Ls=v,w.p={},w}));
}(dayjs_min));

var dayjs = dayjs_min.exports;

const isBaseProduct = (product) => {
  const { attributes, description, name } = product;
  const { images, prices, productId } = product;
  const { showInMenu } = attributes;
  if (typeof showInMenu !== "boolean") {
    return false;
  }
  if (typeof description !== "string") {
    return false;
  }
  if (typeof name !== "string") {
    return false;
  }
  if (typeof productId !== "string") {
    return false;
  }
  if (typeof prices !== "object" || typeof prices === "object" && Object.keys(prices).length < 1) {
    return false;
  }
  if (!Array.isArray(images)) {
    return false;
  }
  return true;
};
const isProductDetails = (product) => {
  const validBaseProduct = isBaseProduct(product);
  if (!validBaseProduct) {
    return false;
  }
  const { questions } = product;
  if (!Array.isArray(questions)) {
    return false;
  }
  return true;
};
const isCartProduct = (product) => {
  const validProductDetails = isProductDetails(product);
  if (!validProductDetails) {
    return false;
  }
  const { hash, createdAt, updatedAt } = product;
  const { amount, priceCategory, comment, questionsAndAnswers } = product;
  if (typeof hash !== "string") {
    return false;
  }
  if (typeof createdAt !== "string") {
    return false;
  }
  if (typeof updatedAt !== "string") {
    return false;
  }
  if (typeof amount !== "number") {
    return false;
  }
  if (typeof comment !== "string") {
    return false;
  }
  if (!["NORMAL", "POINTS"].includes(priceCategory)) {
    return false;
  }
  if (!Array.isArray(questionsAndAnswers)) {
    return false;
  }
  return true;
};
const isFormCartProduct = (product) => {
  var _a;
  const validCartProduct = isCartProduct(product);
  if (!validCartProduct) {
    return false;
  }
  const { questions } = product;
  if (!Array.isArray(questions)) {
    return false;
  }
  const answers = (_a = questions == null ? void 0 : questions[0]) == null ? void 0 : _a.answers;
  if ((answers == null ? void 0 : answers.length) && typeof answers[0].amount === "undefined") {
    return false;
  }
  return true;
};
const getGroupType = (group) => {
  const { min, max, type } = group;
  if (type) {
    if (type === "QUANTITY" || type === "SELECT") {
      return "COUNTER";
    }
    return type;
  }
  if (min === 0 && max === 1) {
    return "CHECKBOX";
  }
  if (min === 1 && max === 1) {
    return "RADIO";
  }
  if (min === 0 && (max === 0 || max === Infinity)) {
    return "COUNTER";
  }
  if (max >= min) {
    return "COUNTER";
  }
  throw new Error(`Modifier group bad configured. min ${min}, max ${max}, type ${type}`);
};
const getModifierType = (config) => {
  const { groupType, min, max, type } = config;
  if (groupType === "RADIO") {
    return "RADIO";
  }
  if (type) {
    if (type === "QUANTITY" || type === "SELECT") {
      return "COUNTER";
    }
    return type;
  }
  if (min === 1 && max === 1) {
    return "RADIO";
  }
  if (min === 0 && max === 1) {
    return "CHECKBOX";
  }
  if (min === 0 && (max === 0 || max === Infinity)) {
    return "COUNTER";
  }
  if (max >= min) {
    return "COUNTER";
  }
  return groupType;
};
const getModifierMin = (groupConfig) => {
  const { min, modifiersCount } = groupConfig;
  if (modifiersCount === 1) {
    return min;
  }
  return 0;
};
const getModifierMax = (groupConfig) => {
  const { max, type } = groupConfig;
  const normalizedMax = max || Infinity;
  if (type === "RADIO") {
    return 1;
  }
  if (type === "CHECKBOX") {
    return 1;
  }
  if (type === "COUNTER") {
    return normalizedMax;
  }
  return normalizedMax;
};
var __defProp$7$1 = Object.defineProperty;
var __defProps$5$1 = Object.defineProperties;
var __getOwnPropDescs$5$1 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$7$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$7$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$7$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$7$1 = (obj, key, value) => key in obj ? __defProp$7$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$7$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$7$1.call(b, prop))
      __defNormalProp$7$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$7$1)
    for (var prop of __getOwnPropSymbols$7$1(b)) {
      if (__propIsEnum$7$1.call(b, prop))
        __defNormalProp$7$1(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$5$1 = (a, b) => __defProps$5$1(a, __getOwnPropDescs$5$1(b));
const multiplyProductQA$3 = (product) => {
  return operationOnProductQA(product, (answer, productAmount) => {
    const accAmount = answer.amount * productAmount;
    const fixedAnswer = multiplyProductQA$3(__spreadProps$5$1(__spreadValues$7$1({}, answer), {
      amount: accAmount
    }));
    return __spreadProps$5$1(__spreadValues$7$1({}, fixedAnswer), { amount: answer.amount * productAmount });
  });
};
const divideProductQA$4 = (product) => {
  return operationOnProductQA(product, (answer, productAmount) => {
    const fixedAnswer = divideProductQA$4(answer);
    return __spreadProps$5$1(__spreadValues$7$1({}, fixedAnswer), { amount: answer.amount / productAmount });
  });
};
const operationOnProductQA = (product, answerEnhancer) => {
  const { amount: productAmount = 1, questionsAndAnswers = [] } = product;
  const newQuestionsAndAnswers = questionsAndAnswers.map((question) => {
    const answers = question.answers.map((answer) => {
      return answerEnhancer(answer, productAmount);
    });
    return __spreadProps$5$1(__spreadValues$7$1({}, question), { answers });
  });
  return __spreadProps$5$1(__spreadValues$7$1({}, product), {
    questionsAndAnswers: newQuestionsAndAnswers
  });
};
var questionsAndAnswers_utils = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  multiplyProductQA: multiplyProductQA$3,
  divideProductQA: divideProductQA$4,
  operationOnProductQA
});
var __defProp$6$1 = Object.defineProperty;
var __defProps$4$1 = Object.defineProperties;
var __getOwnPropDescs$4$1 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$6$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$6$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$6$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6$1 = (obj, key, value) => key in obj ? __defProp$6$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6$1.call(b, prop))
      __defNormalProp$6$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$6$1)
    for (var prop of __getOwnPropSymbols$6$1(b)) {
      if (__propIsEnum$6$1.call(b, prop))
        __defNormalProp$6$1(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$4$1 = (a, b) => __defProps$4$1(a, __getOwnPropDescs$4$1(b));
const toCartProduct$5 = (product, overrides = {}) => {
  if (isCartProduct(product)) {
    return __spreadValues$6$1(__spreadValues$6$1({}, product), overrides);
  }
  if (isProductDetails(product)) {
    return toCartProductFromProductDetails(product, overrides);
  }
  const productDetails = toProductDetails(product);
  return toCartProductFromProductDetails(productDetails, overrides);
};
const toCartProductFromProductDetails = (product, overrides = {}) => {
  const { questionsAndAnswers, priceCategory, amount } = product;
  const newCartProduct = __spreadValues$6$1(__spreadProps$4$1(__spreadValues$6$1({}, product), {
    questionsAndAnswers: questionsAndAnswers != null ? questionsAndAnswers : [],
    amount: amount != null ? amount : 0,
    priceCategory: priceCategory != null ? priceCategory : "NORMAL",
    comment: "",
    alerts: [],
    hash: "",
    createdAt: "",
    updatedAt: ""
  }), overrides);
  return newCartProduct;
};
const toProductDetails = (product, overrides = {}) => {
  return __spreadValues$6$1(__spreadProps$4$1(__spreadValues$6$1({}, product), {
    addDirectlyToCart: true,
    isPriceVip: false,
    manufacturer: [],
    maxAmountForSale: 0,
    questions: [],
    schedule: [],
    benefitId: null,
    categories: null
  }), overrides);
};
const toFormCartProduct = (product, overrides = {}) => {
  if (isFormCartProduct(product)) {
    return __spreadValues$6$1(__spreadValues$6$1({}, product), overrides);
  }
  if (isProductDetails(product)) {
    return toFormCartProductFromProductDetails(product, overrides);
  }
  const productDetails = toProductDetails(product);
  return toFormCartProductFromProductDetails(productDetails, overrides);
};
const toFormCartProductHelper = (product, overrides = {}) => {
  const fixedProduct = divideProductQA$4(product);
  const { priceCategory, productId, amount } = fixedProduct;
  const newQuestions = fixedProduct.questions.map((question) => {
    var _a;
    const pairQuestion = (_a = fixedProduct.questionsAndAnswers) == null ? void 0 : _a.find((q) => {
      return q.questionId === question.questionId;
    });
    const selectedQuestion = pairQuestion != null ? pairQuestion : question;
    const { questionId, min, max } = selectedQuestion;
    const answerConfig = {
      rootId: productId,
      min,
      max,
      type: getGroupType(selectedQuestion),
      modifiersCount: question.answers.length,
      amount,
      path: []
    };
    return __spreadProps$4$1(__spreadValues$6$1({}, selectedQuestion), {
      answers: question.answers.map((answer) => {
        var _a2;
        const pairAnswer = pairQuestion == null ? void 0 : pairQuestion.answers.find((a) => {
          return a.amount > 0 && a.productId === answer.productId;
        });
        const selectedAnswer = pairAnswer != null ? pairAnswer : answer;
        const min2 = getModifierMin(answerConfig);
        const max2 = getModifierMax(answerConfig);
        const type = getModifierType({
          min: min2,
          max: max2,
          groupType: answerConfig.type,
          type: selectedAnswer.renderType
        });
        const nested = selectedAnswer.questions.length;
        const partialNewAnswer = __spreadProps$4$1(__spreadValues$6$1({}, selectedAnswer), {
          amount: (_a2 = selectedAnswer == null ? void 0 : selectedAnswer.amount) != null ? _a2 : 0,
          priceCategory,
          questionId,
          min: min2,
          max: max2,
          renderType: type
        });
        return __spreadProps$4$1(__spreadValues$6$1({}, partialNewAnswer), {
          questions: nested ? toFormCartProductHelper(partialNewAnswer).questions : []
        });
      })
    });
  });
  return __spreadValues$6$1(__spreadProps$4$1(__spreadValues$6$1({}, fixedProduct), {
    questions: newQuestions
  }), overrides);
};
const toFormCartProductFromProductDetails = (product, overrides = {}) => {
  const cartProduct = toCartProductFromProductDetails(product);
  return toFormCartProductHelper(cartProduct, overrides);
};
const toFormCartProductFromAnswer = (modifier, overrides = {}) => {
  return toFormCartProductHelper(modifier, overrides);
};
const normalizeProductDetails = (product) => {
  const { questions } = product;
  return __spreadProps$4$1(__spreadValues$6$1({}, product), {
    questions: questions.map((question) => {
      const { answers } = question;
      return __spreadProps$4$1(__spreadValues$6$1({}, question), {
        answers: answers.map((answer) => {
          const { questions: questions2 } = answer;
          return __spreadProps$4$1(__spreadValues$6$1({}, answer), {
            questions: questions2 != null ? questions2 : []
          });
        })
      });
    })
  });
};
var transformers_utils = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  toCartProduct: toCartProduct$5,
  toFormCartProduct,
  toFormCartProductHelper,
  toFormCartProductFromProductDetails,
  toFormCartProductFromAnswer,
  normalizeProductDetails
});
const getProductTotals = (product, amount = product.amount > 0 ? product.amount : 1) => {
  if (amount < 1) {
    throw new Error("Cannot set the amount of getProductTotals with a value less than 1");
  }
  const cartProduct = product;
  const sanitize = !!cartProduct.updatedAt;
  const sanitized = sanitize ? divideProductQA$4(cartProduct) : product;
  return {
    unitGrossPrice: getProductGrossPrice(sanitized, 1),
    unitTotalDiscounts: getProductTotalDiscounts(),
    unitTotalTaxes: getProductTotalTaxes(sanitized, 1),
    unitNetPrice: getProductNetPrice(sanitized, 1),
    amount,
    grossPrice: getProductGrossPrice(sanitized, amount),
    totalDiscounts: getProductTotalDiscounts(),
    totalTaxes: getProductTotalTaxes(sanitized, amount),
    netPrice: getProductNetPrice(sanitized, amount)
  };
};
const getProductTotalTaxes = (product, setAmount) => {
  const cartProduct = toCartProduct$5(product, { amount: setAmount });
  const { prices, amount, priceCategory } = cartProduct;
  const { taxes, grossPrice } = prices[priceCategory];
  const taxTotal = getTaxTotal(taxes, grossPrice);
  const questionsSum = getModifiersTotalTaxes(cartProduct, setAmount);
  if (taxTotal === null || questionsSum === null) {
    return null;
  }
  return questionsSum + taxTotal * amount;
};
const getModifiersTotalTaxes = (product, setAmount) => {
  var _a, _b;
  return (_b = (_a = product.questionsAndAnswers) == null ? void 0 : _a.reduce((acc, question) => {
    const answersSum = question.answers.reduce((acc2, answer) => {
      const { prices, amount, priceCategory } = answer;
      const { taxes, grossPrice } = prices[priceCategory];
      const taxTotal = getTaxTotal(taxes, grossPrice);
      const childrenTotal = getModifiersTotalTaxes(answer, setAmount);
      return acc2 + amount * (Number(taxTotal) + childrenTotal);
    }, 0);
    return acc + answersSum * setAmount;
  }, 0)) != null ? _b : 0;
};
const getProductGrossPrice = (product, setAmount) => {
  return getProductFieldPrice(product, "grossPrice", setAmount);
};
const getProductTotalDiscounts = (product, setAmount) => {
  return null;
};
const getProductNetPrice = (product, setAmount) => {
  return getProductFieldPrice(product, "netPrice", setAmount);
};
const getProductFieldPrice = (product, field, setAmount) => {
  const cartProduct = toCartProduct$5(product, { amount: setAmount });
  const { prices, amount, priceCategory } = cartProduct;
  const priceField = prices[priceCategory][field];
  const questionsSum = getModifiersFieldTotal(cartProduct, field);
  return (questionsSum + priceField) * amount;
};
const getModifiersFieldTotal = (product, field) => {
  var _a, _b;
  return (_b = (_a = product.questionsAndAnswers) == null ? void 0 : _a.reduce((acc, question) => {
    const answersSum = question.answers.reduce((acc2, answer) => {
      const { prices, amount, priceCategory } = answer;
      const priceField = prices[priceCategory][field];
      const childrenTotal = getModifiersFieldTotal(answer, field);
      return acc2 + amount * (priceField + childrenTotal);
    }, 0);
    return acc + answersSum;
  }, 0)) != null ? _b : 0;
};
const getTaxTotal = (taxes, grossPrice) => {
  if (!taxes.length) {
    return null;
  }
  return taxes.reduce((acc, tax) => {
    return acc + tax.percentage / 100 * grossPrice;
  }, 0);
};

const checkProductAmount = (amount) => {
  if (typeof amount !== "number") {
    throw new Error("Invalid amount received, please make sure you include a valid amount.");
  }
  if (amount < 0) {
    throw new Error(`Cannot receive a negative amount of an item. Please ensure you have added a proper amount of items.`);
  }
  if (amount === 0) {
    throw new Error("Attempting to pass 0 amount. This might indicate a problem with your code. Please ensure you have added a proper amount of items.");
  }
};
const checkModifyProductConfig = (config) => {
  const { store, amount } = config;
  checkStoreId(store);
  checkProductAmount(amount);
};
const checkRemoveProductConfig = (config) => {
  const { store } = config;
  checkStoreId(store);
};
const checkReplaceProductConfig = (config) => {
  const { store } = config;
  checkStoreId(store);
};

var sha1$1 = {exports: {}};

var crypt = {exports: {}};

(function() {
  var base64map
      = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',

  crypt$1 = {
    // Bit-wise rotation left
    rotl: function(n, b) {
      return (n << b) | (n >>> (32 - b));
    },

    // Bit-wise rotation right
    rotr: function(n, b) {
      return (n << (32 - b)) | (n >>> b);
    },

    // Swap big-endian to little-endian and vice versa
    endian: function(n) {
      // If number given, swap endian
      if (n.constructor == Number) {
        return crypt$1.rotl(n, 8) & 0x00FF00FF | crypt$1.rotl(n, 24) & 0xFF00FF00;
      }

      // Else, assume array and swap all items
      for (var i = 0; i < n.length; i++)
        n[i] = crypt$1.endian(n[i]);
      return n;
    },

    // Generate an array of any length of random bytes
    randomBytes: function(n) {
      for (var bytes = []; n > 0; n--)
        bytes.push(Math.floor(Math.random() * 256));
      return bytes;
    },

    // Convert a byte array to big-endian 32-bit words
    bytesToWords: function(bytes) {
      for (var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8)
        words[b >>> 5] |= bytes[i] << (24 - b % 32);
      return words;
    },

    // Convert big-endian 32-bit words to a byte array
    wordsToBytes: function(words) {
      for (var bytes = [], b = 0; b < words.length * 32; b += 8)
        bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
      return bytes;
    },

    // Convert a byte array to a hex string
    bytesToHex: function(bytes) {
      for (var hex = [], i = 0; i < bytes.length; i++) {
        hex.push((bytes[i] >>> 4).toString(16));
        hex.push((bytes[i] & 0xF).toString(16));
      }
      return hex.join('');
    },

    // Convert a hex string to a byte array
    hexToBytes: function(hex) {
      for (var bytes = [], c = 0; c < hex.length; c += 2)
        bytes.push(parseInt(hex.substr(c, 2), 16));
      return bytes;
    },

    // Convert a byte array to a base-64 string
    bytesToBase64: function(bytes) {
      for (var base64 = [], i = 0; i < bytes.length; i += 3) {
        var triplet = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];
        for (var j = 0; j < 4; j++)
          if (i * 8 + j * 6 <= bytes.length * 8)
            base64.push(base64map.charAt((triplet >>> 6 * (3 - j)) & 0x3F));
          else
            base64.push('=');
      }
      return base64.join('');
    },

    // Convert a base-64 string to a byte array
    base64ToBytes: function(base64) {
      // Remove non-base-64 characters
      base64 = base64.replace(/[^A-Z0-9+\/]/ig, '');

      for (var bytes = [], i = 0, imod4 = 0; i < base64.length;
          imod4 = ++i % 4) {
        if (imod4 == 0) continue;
        bytes.push(((base64map.indexOf(base64.charAt(i - 1))
            & (Math.pow(2, -2 * imod4 + 8) - 1)) << (imod4 * 2))
            | (base64map.indexOf(base64.charAt(i)) >>> (6 - imod4 * 2)));
      }
      return bytes;
    }
  };

  crypt.exports = crypt$1;
})();

var charenc = {
  // UTF-8 encoding
  utf8: {
    // Convert a string to a byte array
    stringToBytes: function(str) {
      return charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
    },

    // Convert a byte array to a string
    bytesToString: function(bytes) {
      return decodeURIComponent(escape(charenc.bin.bytesToString(bytes)));
    }
  },

  // Binary encoding
  bin: {
    // Convert a string to a byte array
    stringToBytes: function(str) {
      for (var bytes = [], i = 0; i < str.length; i++)
        bytes.push(str.charCodeAt(i) & 0xFF);
      return bytes;
    },

    // Convert a byte array to a string
    bytesToString: function(bytes) {
      for (var str = [], i = 0; i < bytes.length; i++)
        str.push(String.fromCharCode(bytes[i]));
      return str.join('');
    }
  }
};

var charenc_1 = charenc;

(function() {
  var crypt$1 = crypt.exports,
      utf8 = charenc_1.utf8,
      bin = charenc_1.bin,

  // The core
  sha1 = function (message) {
    // Convert to byte array
    if (message.constructor == String)
      message = utf8.stringToBytes(message);
    else if (typeof Buffer !== 'undefined' && typeof Buffer.isBuffer == 'function' && Buffer.isBuffer(message))
      message = Array.prototype.slice.call(message, 0);
    else if (!Array.isArray(message))
      message = message.toString();

    // otherwise assume byte array

    var m  = crypt$1.bytesToWords(message),
        l  = message.length * 8,
        w  = [],
        H0 =  1732584193,
        H1 = -271733879,
        H2 = -1732584194,
        H3 =  271733878,
        H4 = -1009589776;

    // Padding
    m[l >> 5] |= 0x80 << (24 - l % 32);
    m[((l + 64 >>> 9) << 4) + 15] = l;

    for (var i = 0; i < m.length; i += 16) {
      var a = H0,
          b = H1,
          c = H2,
          d = H3,
          e = H4;

      for (var j = 0; j < 80; j++) {

        if (j < 16)
          w[j] = m[i + j];
        else {
          var n = w[j - 3] ^ w[j - 8] ^ w[j - 14] ^ w[j - 16];
          w[j] = (n << 1) | (n >>> 31);
        }

        var t = ((H0 << 5) | (H0 >>> 27)) + H4 + (w[j] >>> 0) + (
                j < 20 ? (H1 & H2 | ~H1 & H3) + 1518500249 :
                j < 40 ? (H1 ^ H2 ^ H3) + 1859775393 :
                j < 60 ? (H1 & H2 | H1 & H3 | H2 & H3) - 1894007588 :
                         (H1 ^ H2 ^ H3) - 899497514);

        H4 = H3;
        H3 = H2;
        H2 = (H1 << 30) | (H1 >>> 2);
        H1 = H0;
        H0 = t;
      }

      H0 += a;
      H1 += b;
      H2 += c;
      H3 += d;
      H4 += e;
    }

    return [H0, H1, H2, H3, H4];
  },

  // Public API
  api = function (message, options) {
    var digestbytes = crypt$1.wordsToBytes(sha1(message));
    return options && options.asBytes ? digestbytes :
        options && options.asString ? bin.bytesToString(digestbytes) :
        crypt$1.bytesToHex(digestbytes);
  };

  api._blocksize = 16;
  api._digestsize = 20;

  sha1$1.exports = api;
})();

var sha1 = sha1$1.exports;

var __defProp$g = Object.defineProperty;
var __defProps$c = Object.defineProperties;
var __getOwnPropDescs$c = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$g = Object.getOwnPropertySymbols;
var __hasOwnProp$g = Object.prototype.hasOwnProperty;
var __propIsEnum$g = Object.prototype.propertyIsEnumerable;
var __defNormalProp$g = (obj, key, value) => key in obj ? __defProp$g(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$g = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$g.call(b, prop))
      __defNormalProp$g(a, prop, b[prop]);
  if (__getOwnPropSymbols$g)
    for (var prop of __getOwnPropSymbols$g(b)) {
      if (__propIsEnum$g.call(b, prop))
        __defNormalProp$g(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$c = (a, b) => __defProps$c(a, __getOwnPropDescs$c(b));
const { toCartProduct: toCartProduct$4 } = transformers_utils;
const { divideProductQA: divideProductQA$3 } = questionsAndAnswers_utils;
const getProductHash = (product) => {
  const resetedProduct = divideProductQA$3(product);
  const { productId, questionsAndAnswers, priceCategory } = resetedProduct;
  const prunedQuestions = pruneQuestionsAndAnswers(questionsAndAnswers);
  const sortedQuestions = prunedQuestions.sort(sortByQuestionId);
  const questionAndAnswersIds = sortedQuestions.reduce((acc, question) => {
    const sortedAnswers = question.answers.sort(sortByProductId);
    const answerIds = sortedAnswers.reduce((acc2, answer, index) => {
      const { productId: productId2, amount } = answer;
      const childrenHash = getProductHash(answer);
      const concatChildrenHash = childrenHash ? `{${childrenHash}}` : "";
      if (index === 0) {
        return `${productId2}=${amount}${concatChildrenHash}`;
      }
      return `${acc2}|${productId2}=${amount}${concatChildrenHash}`;
    }, "");
    const questionIds = `${question.questionId}:${answerIds}`;
    if (acc === "") {
      return `${questionIds}`;
    }
    return `${acc}-${questionIds}`;
  }, "");
  const sequence = `${productId}-${questionAndAnswersIds}*${priceCategory}`;
  return sha1(sequence);
};
const pruneQuestionsAndAnswers = (questions) => {
  const prunedQuestions = questions.reduce((acc, question) => {
    const prunedAnswers = question.answers.filter((answer) => {
      return answer.amount > 0;
    });
    const prunedAnswersAndChildren = prunedAnswers.map((answer) => {
      const prunedChildren = pruneQuestionsAndAnswers(answer.questionsAndAnswers);
      return __spreadProps$c(__spreadValues$g({}, answer), { questionsAndAnswers: prunedChildren });
    });
    return [...acc, __spreadProps$c(__spreadValues$g({}, question), { answers: prunedAnswersAndChildren })];
  }, []);
  const prunedQuestionsAndAnswers = prunedQuestions.filter((question) => {
    return question.answers.length > 0;
  });
  return prunedQuestionsAndAnswers;
};
const getShoppingCartTotal = (shoppingCart, config = {}) => {
  const initialValue = {
    subtotal: 0,
    totalDiscounts: null,
    shippingCost: null,
    totalTaxes: null,
    totalPoints: null,
    total: 0
  };
  const products = getShoppingCartProducts(shoppingCart);
  if (!products.length)
    return initialValue;
  const totals = products.reduce((acc, product) => {
    const cartProduct = toCartProduct$4(product);
    const { priceCategory } = cartProduct;
    const productTotal = getProductTotals(cartProduct);
    const isPoints = priceCategory === "POINTS";
    const points = isPoints ? productTotal.netPrice : 0;
    const normal = !isPoints ? productTotal.netPrice : 0;
    const subtotalNormal = !isPoints ? productTotal.grossPrice : 0;
    return {
      subtotal: acc.subtotal + subtotalNormal,
      totalDiscounts: productTotal.totalDiscounts !== null ? Number(acc.totalDiscounts) + productTotal.totalDiscounts : null,
      totalTaxes: productTotal.totalTaxes !== null ? Number(acc.totalTaxes) + productTotal.totalTaxes : null,
      shippingCost: null,
      totalPoints: points !== null ? Number(acc.totalPoints) + points : null,
      total: acc.total + normal
    };
  }, initialValue);
  const totalsWithBenefits = applyBenefits(shoppingCart, totals);
  const { shippingCost = shoppingCart.shippingCost } = config;
  if (!shippingCost) {
    return totalsWithBenefits;
  }
  const { grossPrice, netPrice, taxTotal, discountTotal } = shippingCost;
  const totalsWithShippingCost = {
    subtotal: totalsWithBenefits.subtotal + grossPrice,
    totalDiscounts: totalsWithBenefits.totalDiscounts !== null ? totalsWithBenefits.totalDiscounts + discountTotal : discountTotal,
    totalTaxes: totalsWithBenefits.totalTaxes !== null ? totalsWithBenefits.totalTaxes + taxTotal : taxTotal,
    shippingCost: netPrice,
    totalPoints: totalsWithBenefits.totalPoints,
    total: totalsWithBenefits.total + netPrice
  };
  return totalsWithShippingCost;
};
const getShoppingCartProducts = (shoppingCart, storeId) => {
  let stores;
  if (typeof storeId === "undefined") {
    stores = Object.values(shoppingCart.stores);
  } else {
    stores = [shoppingCart.stores[storeId]];
  }
  return stores.reduce((acc, store) => {
    if (!store)
      return acc;
    const products = Object.values(store.products);
    return [...acc, ...products];
  }, []);
};
const applyBenefits = (shoppingCart, shoppingCartTotals) => {
  const additionalInfo = shoppingCart["additional_info"];
  const benefits = shoppingCart["benefits"];
  if (!benefits) {
    return shoppingCartTotals;
  }
  const benefitsValues = Object.values(benefits);
  return benefitsValues.reduce((acc, benefit) => {
    if (benefit.type === "DISCOUNT_PERCENTAGE" && benefit.discountPercentage) {
      return applyBenefitByDiscountPercentage(benefit, acc, shoppingCart);
    }
    if (benefit.type === "DISCOUNT_FIXED" && benefit.discountFixed) {
      return applyBenefitByDiscountFixed(benefit, acc, additionalInfo);
    }
    return acc;
  }, shoppingCartTotals);
};
const applyBenefitByDiscountPercentage = (benefit, shoppingCartTotals, shoppingCart) => {
  let taxValue = 0;
  const additionalInfo = shoppingCart["additional_info"];
  const { billTotal } = shoppingCart;
  const { NORMAL } = billTotal;
  const { discounts } = NORMAL != null ? NORMAL : {};
  discounts == null ? void 0 : discounts.forEach((discount) => {
    if (discount.taxValue) {
      taxValue += discount.taxValue;
    }
  });
  const { subtotal, total: prevTotal } = shoppingCartTotals;
  const { totalDiscounts: prevTotalDiscounts } = shoppingCartTotals;
  const discountPercentage = benefit.discountPercentage * 0.01;
  if (typeof (additionalInfo == null ? void 0 : additionalInfo.copayment) !== "undefined") {
    const copayment = additionalInfo == null ? void 0 : additionalInfo.copayment;
    const totalDiscount2 = copayment * discountPercentage + taxValue;
    const newTotalDiscounts2 = prevTotalDiscounts !== null ? prevTotalDiscounts + totalDiscount2 : totalDiscount2;
    const newTotal2 = (copayment - totalDiscount2).toFixed(4);
    return __spreadProps$c(__spreadValues$g({}, shoppingCartTotals), {
      totalDiscounts: newTotalDiscounts2,
      total: Number(newTotal2)
    });
  }
  const totalDiscount = subtotal * discountPercentage + taxValue;
  const newTotalDiscounts = prevTotalDiscounts !== null ? prevTotalDiscounts + totalDiscount : totalDiscount;
  const newTotal = prevTotal - totalDiscount;
  return __spreadProps$c(__spreadValues$g({}, shoppingCartTotals), {
    totalDiscounts: newTotalDiscounts,
    total: newTotal
  });
};
const applyBenefitByDiscountFixed = (benefit, shoppingCartTotals, additionalInfo) => {
  const { total: prevTotal } = shoppingCartTotals;
  const { totalDiscounts: prevTotalDiscounts } = shoppingCartTotals;
  const discountFixed = Number(benefit.discountFixed);
  if (typeof (additionalInfo == null ? void 0 : additionalInfo.copayment) !== "undefined") {
    const copayment = additionalInfo == null ? void 0 : additionalInfo.copayment;
    const newTotalDiscounts2 = prevTotalDiscounts !== null ? prevTotalDiscounts + discountFixed : discountFixed;
    const newTotal2 = (copayment - discountFixed).toFixed(4);
    return __spreadProps$c(__spreadValues$g({}, shoppingCartTotals), {
      totalDiscounts: newTotalDiscounts2,
      total: Number(newTotal2)
    });
  }
  const newTotalDiscounts = prevTotalDiscounts !== null ? prevTotalDiscounts + discountFixed : discountFixed;
  const newTotal = prevTotal - discountFixed;
  return __spreadProps$c(__spreadValues$g({}, shoppingCartTotals), {
    totalDiscounts: newTotalDiscounts,
    total: newTotal
  });
};
const findProduct = async (config) => {
  const { shoppingCartName } = config;
  const { accountId, customerId, hash, productId, store } = config;
  try {
    if (!hash && typeof productId === "undefined") {
      throw new Error(`You must provide either a product id or a product hash,
        but none were given.`);
    }
    const shoppingCart = await getShoppingCart({
      accountId,
      customerId,
      store,
      shoppingCartName
    });
    if (!shoppingCart)
      return;
    const products = getShoppingCartProducts(shoppingCart);
    let product;
    if (hash) {
      product = products.find((item) => item.hash === hash);
    } else {
      product = products.find((item) => item.productId === productId);
    }
    return product;
  } catch (e) {
    console.error(e);
    return void 0;
  }
};

var __defProp$f = Object.defineProperty;
var __defProps$b = Object.defineProperties;
var __getOwnPropDescs$b = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$f = Object.getOwnPropertySymbols;
var __hasOwnProp$f = Object.prototype.hasOwnProperty;
var __propIsEnum$f = Object.prototype.propertyIsEnumerable;
var __defNormalProp$f = (obj, key, value) => key in obj ? __defProp$f(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$f = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$f.call(b, prop))
      __defNormalProp$f(a, prop, b[prop]);
  if (__getOwnPropSymbols$f)
    for (var prop of __getOwnPropSymbols$f(b)) {
      if (__propIsEnum$f.call(b, prop))
        __defNormalProp$f(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$b = (a, b) => __defProps$b(a, __getOwnPropDescs$b(b));
const { DEFAULT_SHOPPING_CART_NAME } = CONSTANTS;
const createShoppingCart = async (config, overrides = {}) => {
  return new Promise((resolve, reject) => {
    const action = async () => {
      var _a;
      try {
        const reusedConfig = reuseGlobalConfig(config);
        const { shoppingCartName } = reusedConfig;
        const cartsCollection = await getShoppingCartNodes(reusedConfig);
        const newShoppingCart = buildInitialShoppingCart(__spreadValues$f({
          name: shoppingCartName,
          channelId: reusedConfig.channelId
        }, overrides));
        if (!cartsCollection) {
          console.warn(`Couldn't find a shopping cart collection with the given config.
      Please make sure everything is correct in your configuration
      before continue.`);
          resolve(null);
          return null;
        }
        const { name } = newShoppingCart;
        const numberOfCarts = (_a = await cartsCollection.get()) == null ? void 0 : _a.docs.length;
        const maxNumberOfCarts = getState().maxShoppingCarts;
        if (numberOfCarts >= maxNumberOfCarts) {
          throw new Error(`Cannot add more carts. Carts limit (${maxNumberOfCarts}) reached.`);
        }
        const namedCartsDocs = await cartsCollection.where("name", "==", name).get();
        const cartsLength = namedCartsDocs.docs.length;
        if (cartsLength > 0) {
          throw new Error(`Attempted to create a shopping cart with the name ${name}, but there is already one shopping cart with that name.`);
        }
        const node = await cartsCollection.add(newShoppingCart);
        if (!node) {
          console.error("Failed to create a new shopping cart");
          resolve(null);
          return null;
        }
        const updatedCart = __spreadProps$b(__spreadValues$f({}, newShoppingCart), { id: node.id });
        await node.set(updatedCart);
        resolve(updatedCart);
        return updatedCart;
      } catch (e) {
        reject(e);
        return null;
      }
    };
    const { eventLoop, queue } = getState();
    queue.enqueue(action);
    if (!eventLoop.isRunning)
      eventLoop.start();
  });
};
const buildInitialShoppingCart = (overrides = {}) => {
  const date = new Date().toISOString();
  return __spreadValues$f({
    id: "",
    name: DEFAULT_SHOPPING_CART_NAME,
    latitude: -1,
    longitude: -1,
    createdAt: date,
    updatedAt: date,
    channelId: 1,
    stores: {},
    billTotal: {},
    shippingCost: null
  }, overrides);
};

var __defProp$e = Object.defineProperty;
var __defProps$a = Object.defineProperties;
var __getOwnPropDescs$a = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$e = Object.getOwnPropertySymbols;
var __hasOwnProp$e = Object.prototype.hasOwnProperty;
var __propIsEnum$e = Object.prototype.propertyIsEnumerable;
var __defNormalProp$e = (obj, key, value) => key in obj ? __defProp$e(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$e = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$e.call(b, prop))
      __defNormalProp$e(a, prop, b[prop]);
  if (__getOwnPropSymbols$e)
    for (var prop of __getOwnPropSymbols$e(b)) {
      if (__propIsEnum$e.call(b, prop))
        __defNormalProp$e(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$a = (a, b) => __defProps$a(a, __getOwnPropDescs$a(b));
const { PRODUCT_DATE_FORMAT: PRODUCT_DATE_FORMAT$2 } = CONSTANTS;
const { toCartProduct: toCartProduct$3 } = transformers_utils;
const { multiplyProductQA: multiplyProductQA$2, divideProductQA: divideProductQA$2 } = questionsAndAnswers_utils;
const addProduct = async (product, config) => {
  const { createCart } = config;
  if (createCart) {
    const reusedConfig = reuseGlobalConfig(config);
    const shoppingCart = await getShoppingCart(reusedConfig);
    if (!shoppingCart)
      await createShoppingCart(reusedConfig, createCart === true ? void 0 : createCart);
  }
  return new Promise((resolve, reject) => {
    const action = async () => {
      try {
        const reusedConfig = reuseGlobalConfig(config);
        checkModifyProductConfig(reusedConfig);
        const shoppingCartNode = await getShoppingCartNode(reusedConfig);
        if (!shoppingCartNode) {
          console.warn("Cannot add a product because no shopping cart node was found. Please ensure you have a shopping cart before continue.");
          resolve(null);
          return null;
        }
        const shoppingCart = shoppingCartNode.data();
        const updatedCart = addProductToCartHelper(shoppingCart, product, config);
        await shoppingCartNode.ref.set(updatedCart);
        resolve(updatedCart);
        return updatedCart;
      } catch (e) {
        reject(e);
        return null;
      }
    };
    const { eventLoop, queue } = getState();
    queue.enqueue(action);
    if (!eventLoop.isRunning)
      eventLoop.start();
  });
};
const addProductToCartHelper = (shoppingCart, product, config) => {
  const reusedConfig = reuseGlobalConfig(config);
  if (process.env.NODE_ENV === "test") {
    checkModifyProductConfig(reusedConfig);
  }
  const { amount: originalAmount } = product;
  const amount = originalAmount ? originalAmount : 1;
  const hashCartProduct = toCartProduct$3(product, __spreadProps$a(__spreadValues$e({}, reusedConfig), {
    amount: amount != null ? amount : 1
  }));
  const cartProduct = toCartProduct$3(product, reusedConfig);
  const { store: configStore } = reusedConfig;
  const { storeId } = configStore != null ? configStore : {};
  const hash = getProductHash(hashCartProduct);
  const updatedCart = __spreadValues$e({}, shoppingCart);
  const stores = __spreadValues$e({}, shoppingCart.stores);
  const store = getStore(configStore, stores);
  const products = __spreadValues$e({}, store.products);
  const productExist = products[hash];
  const now = dayjs().format(PRODUCT_DATE_FORMAT$2);
  if (!productExist) {
    products[hash] = cartProduct;
    products[hash].hash = hash;
    products[hash].createdAt = now;
  } else {
    products[hash] = divideProductQA$2(products[hash]);
    products[hash].amount += cartProduct.amount;
  }
  products[hash].updatedAt = now;
  let updatedProduct = products[hash];
  updatedProduct = multiplyProductQA$2(updatedProduct);
  const { questionsAndAnswers } = updatedProduct;
  const newCartModifiers = pruneQuestionsAndAnswers(questionsAndAnswers);
  products[hash] = __spreadProps$a(__spreadValues$e({}, updatedProduct), { questionsAndAnswers: newCartModifiers });
  store.products = products;
  stores[storeId] = store;
  updatedCart.stores = stores;
  return updatedCart;
};

var __defProp$d = Object.defineProperty;
var __defProps$9 = Object.defineProperties;
var __getOwnPropDescs$9 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$d = Object.getOwnPropertySymbols;
var __hasOwnProp$d = Object.prototype.hasOwnProperty;
var __propIsEnum$d = Object.prototype.propertyIsEnumerable;
var __defNormalProp$d = (obj, key, value) => key in obj ? __defProp$d(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$d = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$d.call(b, prop))
      __defNormalProp$d(a, prop, b[prop]);
  if (__getOwnPropSymbols$d)
    for (var prop of __getOwnPropSymbols$d(b)) {
      if (__propIsEnum$d.call(b, prop))
        __defNormalProp$d(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$9 = (a, b) => __defProps$9(a, __getOwnPropDescs$9(b));
const { PRODUCT_DATE_FORMAT: PRODUCT_DATE_FORMAT$1 } = CONSTANTS;
const { toCartProduct: toCartProduct$2 } = transformers_utils;
const { multiplyProductQA: multiplyProductQA$1, divideProductQA: divideProductQA$1 } = questionsAndAnswers_utils;
const subtractProduct = async (product, config) => {
  return new Promise((resolve, reject) => {
    const action = async () => {
      try {
        const reusedConfig = reuseGlobalConfig(config);
        checkModifyProductConfig(reusedConfig);
        const shoppingCartNode = await getShoppingCartNode(reusedConfig);
        if (!shoppingCartNode) {
          console.warn("Cannot subtract product because no shopping cart nodes found. Please ensure you have a shopping cart before continue.");
          resolve(null);
          return null;
        }
        const shoppingCart = shoppingCartNode.data();
        const updatedCart = subtractProductHelper(shoppingCart, product, reusedConfig);
        await shoppingCartNode.ref.set(updatedCart);
        resolve(updatedCart);
        return updatedCart;
      } catch (e) {
        reject(e);
        return null;
      }
    };
    const { eventLoop, queue } = getState();
    queue.enqueue(action);
    if (!eventLoop.isRunning)
      eventLoop.start();
  });
};
const subtractProductHelper = (shoppingCart, product, config) => {
  const reusedConfig = reuseGlobalConfig(config);
  if (process.env.NODE_ENV === "test") {
    checkModifyProductConfig(reusedConfig);
  }
  const { amount: originalAmount } = product;
  const amount = originalAmount ? originalAmount : 1;
  const hashCartProduct = toCartProduct$2(product, __spreadProps$9(__spreadValues$d({}, reusedConfig), {
    amount: amount != null ? amount : 1
  }));
  const cartProduct = toCartProduct$2(product, reusedConfig);
  const { store: configStore } = reusedConfig;
  const { storeId } = configStore != null ? configStore : {};
  const hash = getProductHash(hashCartProduct);
  let updatedCart = __spreadValues$d({}, shoppingCart);
  const stores = __spreadValues$d({}, shoppingCart.stores);
  if (typeof stores[storeId] === "undefined") {
    console.warn(`StoreId given is invalid. There is no store with id ${storeId} on the shopping cart.`);
    return shoppingCart;
  }
  const store = getStore(configStore, stores);
  const products = __spreadValues$d({}, store.products);
  const productExist = products[hash];
  const now = dayjs().format(PRODUCT_DATE_FORMAT$1);
  if (!productExist) {
    console.warn(`Attempting to subtract the amount of product that is not in the given shopping cart store.`);
    return shoppingCart;
  }
  products[hash] = divideProductQA$1(products[hash]);
  const newAmount = products[hash].amount - cartProduct.amount;
  if (newAmount > 0) {
    products[hash].amount = newAmount;
    products[hash].updatedAt = now;
    products[hash] = multiplyProductQA$1(products[hash]);
  } else {
    delete products[hash];
    updatedCart = cleanShoppingCart(shoppingCart, product);
  }
  store.products = products;
  if (!Object.keys(store.products).length) {
    delete stores[storeId];
  } else {
    stores[storeId] = store;
  }
  updatedCart.stores = stores;
  return updatedCart;
};

var __defProp$c = Object.defineProperty;
var __getOwnPropSymbols$c = Object.getOwnPropertySymbols;
var __hasOwnProp$c = Object.prototype.hasOwnProperty;
var __propIsEnum$c = Object.prototype.propertyIsEnumerable;
var __defNormalProp$c = (obj, key, value) => key in obj ? __defProp$c(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$c = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$c.call(b, prop))
      __defNormalProp$c(a, prop, b[prop]);
  if (__getOwnPropSymbols$c)
    for (var prop of __getOwnPropSymbols$c(b)) {
      if (__propIsEnum$c.call(b, prop))
        __defNormalProp$c(a, prop, b[prop]);
    }
  return a;
};
const { toCartProduct: toCartProduct$1 } = transformers_utils;
const removeProduct = async (product, config = {}) => {
  return new Promise((resolve, reject) => {
    const action = async () => {
      try {
        const reusedConfig = reuseGlobalConfig(config);
        checkRemoveProductConfig(reusedConfig);
        const shoppingCartNode = await getShoppingCartNode(reusedConfig);
        if (!shoppingCartNode) {
          console.warn("Cannot remove a product because no shopping cart nodes found. Please ensure you have a shopping cart before continue.");
          resolve(null);
          return null;
        }
        const shoppingCart = shoppingCartNode.data();
        const cart = removeProductHelper(shoppingCart, product, reusedConfig);
        const updatedCart = cleanShoppingCart(cart, product);
        await shoppingCartNode.ref.set(updatedCart);
        resolve(updatedCart);
        return updatedCart;
      } catch (e) {
        reject(e);
        return null;
      }
    };
    const { eventLoop, queue } = getState();
    queue.enqueue(action);
    if (!eventLoop.isRunning)
      eventLoop.start();
  });
};
const removeProductHelper = (shoppingCart, product, config) => {
  const reusedConfig = reuseGlobalConfig(config);
  if (process.env.NODE_ENV === "test") {
    checkRemoveProductConfig(reusedConfig);
  }
  let productHash = product.hash;
  if (!productHash) {
    const cartProduct = toCartProduct$1(product);
    productHash = getProductHash(cartProduct);
  }
  const { store: configStore } = reusedConfig;
  const { storeId } = configStore != null ? configStore : {};
  const updatedCart = __spreadValues$c({}, shoppingCart);
  const stores = __spreadValues$c({}, shoppingCart.stores);
  if (typeof stores[storeId] === "undefined") {
    console.warn(`StoreId given is invalid. There is no store with id ${storeId} on the shopping cart.`);
    return shoppingCart;
  }
  const store = getStore(configStore, stores);
  const products = __spreadValues$c({}, store.products);
  const productExist = products[productHash];
  if (!productExist) {
    console.warn(`Attempting to remove product that is not in the given shopping cart store.`);
    return shoppingCart;
  }
  delete products[productHash];
  store.products = products;
  if (!Object.keys(store.products).length) {
    delete stores[storeId];
  } else {
    stores[storeId] = store;
  }
  updatedCart.stores = stores;
  return updatedCart;
};

var __defProp$b = Object.defineProperty;
var __defProps$8 = Object.defineProperties;
var __getOwnPropDescs$8 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$b = Object.getOwnPropertySymbols;
var __hasOwnProp$b = Object.prototype.hasOwnProperty;
var __propIsEnum$b = Object.prototype.propertyIsEnumerable;
var __defNormalProp$b = (obj, key, value) => key in obj ? __defProp$b(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$b = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$b.call(b, prop))
      __defNormalProp$b(a, prop, b[prop]);
  if (__getOwnPropSymbols$b)
    for (var prop of __getOwnPropSymbols$b(b)) {
      if (__propIsEnum$b.call(b, prop))
        __defNormalProp$b(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$8 = (a, b) => __defProps$8(a, __getOwnPropDescs$8(b));
const { PRODUCT_DATE_FORMAT } = CONSTANTS;
const { toCartProduct } = transformers_utils;
const { multiplyProductQA, divideProductQA } = questionsAndAnswers_utils;
const setProduct = async (product, config = {}) => {
  return new Promise((resolve, reject) => {
    const action = async () => {
      var _a, _b;
      try {
        const reusedConfig = reuseGlobalConfig(config);
        const amount = (_b = (_a = reusedConfig.amount) != null ? _a : product == null ? void 0 : product.amount) != null ? _b : 1;
        const actionConfig = __spreadProps$8(__spreadValues$b({}, reusedConfig), { amount });
        checkModifyProductConfig(actionConfig);
        const shoppingCartNode = await getShoppingCartNode(reusedConfig);
        if (!shoppingCartNode) {
          console.warn("Cannot set product because no shopping cart nodes found. Please ensure you have a shopping cart before continue.");
          resolve(null);
          return null;
        }
        const shoppingCart = shoppingCartNode.data();
        const cart = setProductHelper(shoppingCart, product, actionConfig);
        const updatedCart = cleanShoppingCart(cart, product);
        await shoppingCartNode.ref.set(updatedCart);
        resolve(updatedCart);
        return updatedCart;
      } catch (e) {
        reject(e);
        return null;
      }
    };
    const { eventLoop, queue } = getState();
    queue.enqueue(action);
    if (!eventLoop.isRunning)
      eventLoop.start();
  });
};
const setProductHelper = (shoppingCart, product, config) => {
  var _a;
  const reusedConfig = reuseGlobalConfig(config);
  if (process.env.NODE_ENV === "test") {
    checkModifyProductConfig(reusedConfig);
  }
  const amount = (_a = product == null ? void 0 : product.amount) != null ? _a : 1;
  const hashCartProduct = toCartProduct(product, __spreadProps$8(__spreadValues$b({}, reusedConfig), { amount }));
  const { store: configStore } = reusedConfig;
  const { storeId } = configStore != null ? configStore : {};
  const hash = getProductHash(hashCartProduct);
  const updatedCart = __spreadValues$b({}, shoppingCart);
  const stores = __spreadValues$b({}, shoppingCart.stores);
  const store = getStore(configStore, stores);
  const products = __spreadValues$b({}, store.products);
  const productExist = products[hash];
  const now = dayjs().format(PRODUCT_DATE_FORMAT);
  products[hash] = hashCartProduct;
  if (!productExist) {
    products[hash].createdAt = now;
    products[hash].hash = hash;
  } else {
    products[hash] = divideProductQA(products[hash]);
  }
  products[hash].updatedAt = now;
  let updatedProduct = toCartProduct(products[hash], reusedConfig);
  updatedProduct = multiplyProductQA(updatedProduct);
  const { questionsAndAnswers } = updatedProduct;
  const newCartModifiers = pruneQuestionsAndAnswers(questionsAndAnswers);
  products[hash] = __spreadProps$8(__spreadValues$b({}, updatedProduct), { questionsAndAnswers: newCartModifiers });
  store.products = products;
  stores[storeId] = __spreadProps$8(__spreadValues$b({}, store), { polygons: null });
  updatedCart.stores = stores;
  return updatedCart;
};

var __defProp$a = Object.defineProperty;
var __defProps$7 = Object.defineProperties;
var __getOwnPropDescs$7 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$a = Object.getOwnPropertySymbols;
var __hasOwnProp$a = Object.prototype.hasOwnProperty;
var __propIsEnum$a = Object.prototype.propertyIsEnumerable;
var __defNormalProp$a = (obj, key, value) => key in obj ? __defProp$a(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$a = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$a.call(b, prop))
      __defNormalProp$a(a, prop, b[prop]);
  if (__getOwnPropSymbols$a)
    for (var prop of __getOwnPropSymbols$a(b)) {
      if (__propIsEnum$a.call(b, prop))
        __defNormalProp$a(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$7 = (a, b) => __defProps$7(a, __getOwnPropDescs$7(b));
const replaceProduct = async (product, config) => {
  return new Promise((resolve, reject) => {
    const action = async () => {
      try {
        const reusedConfig = reuseGlobalConfig(config);
        checkReplaceProductConfig(reusedConfig);
        const shoppingCartNode = await getShoppingCartNode(reusedConfig);
        if (!shoppingCartNode) {
          console.warn("Cannot replace product because no shopping cart nodes found. Please ensure you have a shopping cart before continue.");
          resolve(null);
          return null;
        }
        const shoppingCart = shoppingCartNode.data();
        const cart = replaceProductHelper(shoppingCart, product, reusedConfig);
        const updatedCart = cleanShoppingCart(cart, product);
        await shoppingCartNode.ref.set(updatedCart);
        resolve(updatedCart);
        return updatedCart;
      } catch (e) {
        reject(e);
        return null;
      }
    };
    const { eventLoop, queue } = getState();
    queue.enqueue(action);
    if (!eventLoop.isRunning)
      eventLoop.start();
  });
};
const replaceProductHelper = (shoppingCart, product, config) => {
  const reusedConfig = reuseGlobalConfig(config);
  if (process.env.NODE_ENV === "test") {
    checkReplaceProductConfig(reusedConfig);
  }
  const { hash: configHash } = reusedConfig;
  const hash = configHash != null ? configHash : product.hash;
  const { store: configStore } = reusedConfig;
  const { storeId } = configStore != null ? configStore : {};
  const stores = __spreadValues$a({}, shoppingCart.stores);
  const store = getStore(configStore, stores);
  const products = __spreadValues$a({}, store.products);
  const productExist = products[hash];
  if (!productExist) {
    console.warn("Cannot replace a product because no product was found in the given store");
    return shoppingCart;
  }
  delete products[hash];
  store.products = products;
  if (!Object.keys(store.products).length) {
    delete stores[storeId];
  } else {
    stores[storeId] = store;
  }
  let updatedCart = __spreadValues$a({}, shoppingCart);
  updatedCart.stores = stores;
  const newProduct = __spreadProps$7(__spreadValues$a({}, product), { amount: 0 });
  updatedCart = addProductToCartHelper(updatedCart, newProduct, reusedConfig);
  return updatedCart;
};

var __defProp$9 = Object.defineProperty;
var __defProps$6 = Object.defineProperties;
var __getOwnPropDescs$6 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$9 = Object.getOwnPropertySymbols;
var __hasOwnProp$9 = Object.prototype.hasOwnProperty;
var __propIsEnum$9 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$9 = (obj, key, value) => key in obj ? __defProp$9(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$9 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$9.call(b, prop))
      __defNormalProp$9(a, prop, b[prop]);
  if (__getOwnPropSymbols$9)
    for (var prop of __getOwnPropSymbols$9(b)) {
      if (__propIsEnum$9.call(b, prop))
        __defNormalProp$9(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$6 = (a, b) => __defProps$6(a, __getOwnPropDescs$6(b));
const emptyShoppingCart = async (config) => {
  return new Promise((resolve, reject) => {
    const action = async () => {
      try {
        const shoppingCartNode = await getShoppingCartNode(config);
        const { shoppingCartName, vendorId } = reuseGlobalConfig(config);
        if (!shoppingCartNode) {
          logDebug(`Cannot empty cart, shopping cart nodes not found. Please ensure you have a shopping cart with name ${shoppingCartName} before continue.`);
          resolve(null);
          return null;
        }
        const shoppingCart = await shoppingCartNode.data();
        delete shoppingCart.pickUpTime;
        const stores = {};
        if (typeof vendorId !== "undefined") {
          const filteredStores = Object.values(shoppingCart.stores).filter((store) => store.vendor.id != vendorId);
          filteredStores.forEach((store) => {
            stores[`${store.storeId}`] = store;
          });
        }
        const cart = __spreadProps$6(__spreadValues$9({}, shoppingCart), { stores });
        const updatedCart = cleanShoppingCart(cart);
        await shoppingCartNode.ref.set(updatedCart);
        resolve(updatedCart);
        return updatedCart;
      } catch (e) {
        reject(e);
        return null;
      }
    };
    const { eventLoop, queue } = getState();
    queue.enqueue(action);
    if (!eventLoop.isRunning)
      eventLoop.start();
  });
};

const deleteShoppingCart = async (config) => {
  return new Promise((resolve, reject) => {
    const action = async () => {
      try {
        const shoppingCartNode = await getShoppingCartNode(config);
        const { shoppingCartName } = reuseGlobalConfig(config);
        if (!shoppingCartNode) {
          logDebug(`Couldn't find any shopping cart with name ${shoppingCartName} with the given config.`);
          resolve(null);
          return null;
        }
        const shoppingCart = shoppingCartNode.data();
        await shoppingCartNode.ref.delete();
        resolve(shoppingCart);
        return shoppingCart;
      } catch (e) {
        reject(e);
        return null;
      }
    };
    const { eventLoop, queue } = getState();
    queue.enqueue(action);
    if (!eventLoop.isRunning)
      eventLoop.start();
  });
};

const checkValidateShoppingCartConfig = (config, headers) => {
  const { apiURL } = config;
  checkApiURL(apiURL);
  checkCommonHeaders(headers);
};

const initAuth = (app) => {
  if (typeof window === "undefined") {
    return void 0;
  }
  return app.__internals__.auth();
};

const commonHeaders = {
  "Content-Type": "application/json"
};

var __defProp$8 = Object.defineProperty;
var __defProps$5 = Object.defineProperties;
var __getOwnPropDescs$5 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$8 = Object.getOwnPropertySymbols;
var __hasOwnProp$8 = Object.prototype.hasOwnProperty;
var __propIsEnum$8 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$8 = (obj, key, value) => key in obj ? __defProp$8(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$8 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$8.call(b, prop))
      __defNormalProp$8(a, prop, b[prop]);
  if (__getOwnPropSymbols$8)
    for (var prop of __getOwnPropSymbols$8(b)) {
      if (__propIsEnum$8.call(b, prop))
        __defNormalProp$8(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$5 = (a, b) => __defProps$5(a, __getOwnPropDescs$5(b));
const buildServiceHeaders = async (headers) => {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const { artisnApp, accountId: localAccountId } = getState();
  const { settings } = artisnApp;
  const { platform, accountId: globalAccountId } = settings;
  const account = (_d = (_c = (_b = (_a = headers.account) == null ? void 0 : _a.toString()) != null ? _b : localAccountId == null ? void 0 : localAccountId.toString()) != null ? _c : globalAccountId == null ? void 0 : globalAccountId.toString()) != null ? _d : "";
  const selectedPlatform = (_f = (_e = headers == null ? void 0 : headers.Platform) != null ? _e : platform) != null ? _f : "";
  const Platform = selectedPlatform;
  const Authorization = (_h = (_g = headers == null ? void 0 : headers.Authorization) != null ? _g : await getArtisnAuthToken()) != null ? _h : "";
  return new Headers(__spreadProps$5(__spreadValues$8(__spreadValues$8({}, commonHeaders), headers), {
    Authorization,
    Platform,
    account
  }));
};
const getArtisnAuthToken = async (forceRefresh) => {
  var _a;
  const { artisnApp } = getState();
  if (!artisnApp)
    return;
  const auth = () => initAuth(artisnApp);
  const token = await ((_a = auth().currentUser) == null ? void 0 : _a.getIdToken(forceRefresh));
  if (!token) {
    logError("Please make sure you are authenticated before trying to call a restricted action.");
    return;
  }
  return `Bearer ${token}`;
};

var __defProp$7 = Object.defineProperty;
var __getOwnPropSymbols$7 = Object.getOwnPropertySymbols;
var __hasOwnProp$7 = Object.prototype.hasOwnProperty;
var __propIsEnum$7 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$7 = (obj, key, value) => key in obj ? __defProp$7(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$7 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$7.call(b, prop))
      __defNormalProp$7(a, prop, b[prop]);
  if (__getOwnPropSymbols$7)
    for (var prop of __getOwnPropSymbols$7(b)) {
      if (__propIsEnum$7.call(b, prop))
        __defNormalProp$7(a, prop, b[prop]);
    }
  return a;
};
const validateShoppingCart$1 = async (config, headers) => {
  const { apiURL } = getState().artisnApp;
  const { id, latitude, longitude } = config;
  const selectedHeaders = await buildServiceHeaders(__spreadValues$7({}, headers));
  let url = `${apiURL}/api/shopping-cart/${id}/validateShoppingCart`;
  try {
    if (typeof latitude !== "undefined" && typeof longitude !== "undefined") {
      url += `?latitude=${latitude}&longitude=${longitude}`;
    }
    const data = await fetch(url, {
      headers: selectedHeaders
    }).then(async (data2) => {
      return await data2.json();
    });
    const shoppingCart = data.data;
    if (!shoppingCart)
      throw new Error("No shopping cart was found.");
    const storeAlerts = Object.values(shoppingCart.stores).reduce((acc, store) => {
      if (store.alerts.length)
        return [...acc, ...store.alerts];
      return acc;
    }, []);
    const products = getShoppingCartProducts(shoppingCart);
    const productsAlerts = products.map((item) => item.alerts).flat();
    const alerts = {
      stores: storeAlerts,
      products: productsAlerts
    };
    return alerts;
  } catch (e) {
    console.error(e.message);
    return {
      stores: [
        {
          errorLevel: 1,
          message: "Ocurri\xF3 un error desconocido, comun\xEDquese con soporte",
          type: ""
        }
      ],
      products: []
    };
  }
};

const validateShoppingCart = async (config = {}, headers) => {
  const reusedConfig = reuseGlobalConfig(config);
  checkValidateShoppingCartConfig(reusedConfig, headers);
  const { latitude, longitude, shoppingCartName } = reusedConfig;
  const shoppingCartNode = await getShoppingCartNode(reusedConfig);
  const { id } = shoppingCartNode != null ? shoppingCartNode : {};
  if (typeof id === "undefined") {
    console.error(`Cannot use undefined as a shopping cart id. Shopping cart ${shoppingCartName} was not found. Validation canceled.`);
    return;
  }
  return await validateShoppingCart$1({ id, latitude, longitude }, headers);
};

var __defProp$6 = Object.defineProperty;
var __defProps$4 = Object.defineProperties;
var __getOwnPropDescs$4 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$6 = Object.getOwnPropertySymbols;
var __hasOwnProp$6 = Object.prototype.hasOwnProperty;
var __propIsEnum$6 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6 = (obj, key, value) => key in obj ? __defProp$6(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6.call(b, prop))
      __defNormalProp$6(a, prop, b[prop]);
  if (__getOwnPropSymbols$6)
    for (var prop of __getOwnPropSymbols$6(b)) {
      if (__propIsEnum$6.call(b, prop))
        __defNormalProp$6(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$4 = (a, b) => __defProps$4(a, __getOwnPropDescs$4(b));
const getInitialBenefitsWallet = (overrides = {}) => {
  return __spreadValues$6({ benefits: [] }, overrides);
};
const mapCollectionToBenefits = (benefitsNode, hash) => {
  const benefits = Object.values(benefitsNode).map((benefit) => {
    const newBenefit = __spreadProps$4(__spreadValues$6({}, benefit), { hash });
    return newBenefit;
  });
  return benefits;
};
const updateBenefitsWallets = (walletName, newWallet) => {
  const { wallets } = getState();
  const newWallets = __spreadProps$4(__spreadValues$6({}, wallets), {
    [walletName]: __spreadValues$6({}, newWallet)
  });
  setState({ wallets: newWallets });
};
const getBenefitsNode = async (config = {}) => {
  var _a, _b;
  const {
    artisnApp,
    customerId: globalCustomerId,
    accountId: globalAccountId
  } = getState();
  const { accountId, customerId } = config;
  checkArtisnAppProvided();
  checkMinimumConfigProvided(config);
  const db = artisnApp == null ? void 0 : artisnApp.__internals__.firestore();
  const benefitsCollection = await ((_b = (_a = db == null ? void 0 : db.collection("benefitsByUser")) == null ? void 0 : _a.doc(String(customerId != null ? customerId : globalCustomerId))) == null ? void 0 : _b.collection(String(accountId != null ? accountId : globalAccountId)));
  return benefitsCollection;
};
const getWalletNode = async (config) => {
  try {
    const benefitsCollection = await getBenefitsNode(config);
    if (!benefitsCollection)
      return;
    const newestBenefits = await benefitsCollection.get().then((benefitsByUser) => {
      return benefitsByUser.docs[0];
    });
    return newestBenefits;
  } catch (e) {
    console.error(e.message);
  }
};
const getWallet = async (config) => {
  const benefitsByUserNode = await getWalletNode(config);
  if (!benefitsByUserNode)
    return;
  if (Object.keys(benefitsByUserNode.data()).length === 0)
    return [];
  const hash = benefitsByUserNode.id;
  const benefits = Object.values(benefitsByUserNode.data()).map((benefit) => {
    const newBenefit = __spreadProps$4(__spreadValues$6({}, benefit), { hash });
    return newBenefit;
  });
  return benefits;
};

var __defProp$5 = Object.defineProperty;
var __defProps$3 = Object.defineProperties;
var __getOwnPropDescs$3 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$5 = Object.getOwnPropertySymbols;
var __hasOwnProp$5 = Object.prototype.hasOwnProperty;
var __propIsEnum$5 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5 = (obj, key, value) => key in obj ? __defProp$5(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5.call(b, prop))
      __defNormalProp$5(a, prop, b[prop]);
  if (__getOwnPropSymbols$5)
    for (var prop of __getOwnPropSymbols$5(b)) {
      if (__propIsEnum$5.call(b, prop))
        __defNormalProp$5(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$3 = (a, b) => __defProps$3(a, __getOwnPropDescs$3(b));
const fetchWalletByUser = async (config, headers) => {
  const { apiURL } = getState().artisnApp;
  const { vendorId, customerId } = config;
  const selectedHeaders = await buildServiceHeaders(__spreadProps$3(__spreadValues$5({}, headers), {
    uid: customerId.toString()
  }));
  let serviceURL = "/api/shopping-cart/retrieveBenefits";
  if (vendorId)
    serviceURL = serviceURL + `?vendorId=${vendorId}`;
  const url = `${apiURL}${serviceURL}`;
  const data = await fetch(url, {
    headers: selectedHeaders
  }).then(async (data2) => {
    return await data2.json();
  }).catch((e) => {
    throw new Error(`Failed to retrieve the user's wallet
 ${e.message}`);
  });
  if (!data) {
    throw new Error(`The benefits wallet is not defined. Make sure coupons are well configured`);
  }
};
const redeemCouponService = async (config, code, headers) => {
  const { apiURL } = getState().artisnApp;
  const { customerId } = config;
  const selectedHeaders = await buildServiceHeaders(__spreadProps$3(__spreadValues$5({}, headers), {
    uid: customerId.toString()
  }));
  try {
    const url = `${apiURL}/api/wallet_profit/apply`;
    const result = await fetch(url, {
      method: "post",
      body: JSON.stringify({ code }),
      headers: selectedHeaders
    }).then(async (data2) => {
      return await data2.json();
    });
    const response = result;
    const { code: responseCode, data, message } = response;
    if (responseCode === 200)
      return true;
    if (!data)
      throw new Error(message.code);
    logError(`Unhandled response when redeeming coupon ${JSON.stringify(response, void 0, 2)}`);
    return false;
  } catch (e) {
    throw new Error(e.message);
  }
};
const applyBenefitService = async (config, headers) => {
  var _a, _b;
  const { benefit, customerId, shoppingCartId } = config;
  const { benefitId } = benefit;
  const { apiURL } = getState().artisnApp;
  const selectedHeaders = await buildServiceHeaders(__spreadProps$3(__spreadValues$5({}, headers), {
    uid: customerId.toString()
  }));
  const selectedBenefitBody = {
    benefitId,
    shoppingCartId
  };
  const url = `${apiURL}/api/shopping-cart/applyBenefit`;
  const data = await fetch(url, {
    method: "post",
    body: JSON.stringify(selectedBenefitBody),
    headers: selectedHeaders
  }).then(async (data2) => {
    return await data2.json();
  });
  if ((data == null ? void 0 : data.code) !== 200) {
    throw new Error((_b = (_a = data.message) == null ? void 0 : _a.message) != null ? _b : data.message);
  }
  if ((data == null ? void 0 : data.data.length) === 0) {
    throw new Error("No benefits were applied to the current shopping cart");
  }
  return data;
};
const fetchStoreCoupons = async (config, headers) => {
  const { apiURL } = getState().artisnApp;
  const { vendorId } = config;
  checkVendorId(vendorId);
  const url = `${apiURL}/api/couponByPromotion/categories?orderBy=created_at&sortBy=DESC&vendorId=${vendorId}`;
  const selectedHeaders = await buildServiceHeaders(__spreadValues$5({}, headers));
  const data = await fetch(url, {
    method: "get",
    headers: selectedHeaders
  }).then(async (data2) => {
    return await data2.json();
  });
  if ((data == null ? void 0 : data.code) !== 200)
    throw new Error(data.message);
  return data.data;
};
const fetchStoreCouponDetail = async (config, headers) => {
  const { apiURL } = getState().artisnApp;
  const { couponId, countryId } = config;
  checkStoreCouponDetailConfig(config);
  const url = `${apiURL}/api/coupon/${couponId}?countryId=${countryId}`;
  const selectedHeaders = await buildServiceHeaders(__spreadValues$5({}, headers));
  const data = await fetch(url, {
    method: "get",
    headers: selectedHeaders
  }).then(async (data2) => {
    return await data2.json();
  });
  if ((data == null ? void 0 : data.code) !== 200)
    throw new Error(data.message);
  return data.data;
};

var __defProp$4 = Object.defineProperty;
var __defProps$2 = Object.defineProperties;
var __getOwnPropDescs$2 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$4 = Object.getOwnPropertySymbols;
var __hasOwnProp$4 = Object.prototype.hasOwnProperty;
var __propIsEnum$4 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4 = (obj, key, value) => key in obj ? __defProp$4(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4.call(b, prop))
      __defNormalProp$4(a, prop, b[prop]);
  if (__getOwnPropSymbols$4)
    for (var prop of __getOwnPropSymbols$4(b)) {
      if (__propIsEnum$4.call(b, prop))
        __defNormalProp$4(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$2 = (a, b) => __defProps$2(a, __getOwnPropDescs$2(b));
const listenBenefitsWallet = (onSnapshot, config, headers) => {
  const reusedConfig = reuseGlobalConfig(config);
  checkMinimumFetchWalletConfigProvided(reusedConfig);
  checkCommonHeaders(headers);
  const { shoppingCartName, customerId, anonymous } = reusedConfig;
  const { wallets } = getState();
  const walletExists = wallets[shoppingCartName];
  if (anonymous)
    return () => unsubscriber(shoppingCartName);
  if (walletExists) {
    logError(`There is already a listener for wallet of name ${shoppingCartName}. Either unsubscribe to the other listener or create a new listener for a different cart`);
    return () => unsubscriber(shoppingCartName);
  }
  const newWallet = getInitialBenefitsWallet();
  updateBenefitsWallets(shoppingCartName, __spreadProps$2(__spreadValues$4({}, newWallet), { onSnapshot }));
  let dbUnsubscriber = void 0;
  (async () => {
    const fetchConfig = __spreadProps$2(__spreadValues$4({}, reusedConfig), { customerId });
    try {
      await fetchWalletByUser(fetchConfig, headers);
      const benefitsNode = await getBenefitsNode(reusedConfig);
      if (!benefitsNode) {
        throw new Error("Failed to retrieve the benefits wallet node");
      }
      dbUnsubscriber = benefitsNode.onSnapshot(async (collection) => {
        var _a, _b, _c;
        const benefitsByUser = (_c = (_b = (_a = collection == null ? void 0 : collection.docs) == null ? void 0 : _a[0]) == null ? void 0 : _b.data()) != null ? _c : {};
        if (Object.keys(benefitsByUser).length === 0) {
          const newWallet3 = getInitialBenefitsWallet();
          updateBenefitsWallets(shoppingCartName, __spreadProps$2(__spreadValues$4({}, newWallet3), {
            onSnapshot
          }));
          onSnapshot(newWallet3);
          return;
        }
        const hash = collection.docs[0].id;
        const benefits = mapCollectionToBenefits(benefitsByUser, hash);
        const newWallet2 = getInitialBenefitsWallet({
          benefits
        });
        updateBenefitsWallets(shoppingCartName, __spreadProps$2(__spreadValues$4({}, newWallet2), { onSnapshot }));
        onSnapshot(newWallet2);
      });
    } catch (e) {
      console.error(e.message);
    }
  })();
  return () => unsubscriber(shoppingCartName, dbUnsubscriber);
};
const unsubscriber = (shoppingCartName, unsubscribe) => {
  const { wallets } = getState();
  const newWallets = __spreadValues$4({}, wallets);
  delete newWallets[shoppingCartName];
  setState({ wallets: newWallets });
  if (unsubscribe)
    unsubscribe();
};

var __defProp$3 = Object.defineProperty;
var __getOwnPropSymbols$3 = Object.getOwnPropertySymbols;
var __hasOwnProp$3 = Object.prototype.hasOwnProperty;
var __propIsEnum$3 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3 = (obj, key, value) => key in obj ? __defProp$3(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3.call(b, prop))
      __defNormalProp$3(a, prop, b[prop]);
  if (__getOwnPropSymbols$3)
    for (var prop of __getOwnPropSymbols$3(b)) {
      if (__propIsEnum$3.call(b, prop))
        __defNormalProp$3(a, prop, b[prop]);
    }
  return a;
};
const applyBenefit = async (config) => {
  const reusedConfig = reuseGlobalConfig(config);
  checkMinimumConfigProvided(reusedConfig);
  const { benefitId, shoppingCartName } = reusedConfig;
  const { wallets } = getState();
  const errorMessage = checkBenefitConfigProvided(wallets, shoppingCartName, reusedConfig);
  if (errorMessage) {
    logError(errorMessage);
    return;
  }
  const activeWallet = wallets[shoppingCartName];
  const benefits = activeWallet.benefits;
  const benefitToApply = benefits.find((benefit) => benefit.benefitId === benefitId);
  if (!benefitToApply) {
    logError(`No benefit was found in the benefits wallet with the benefitId provided.`);
    return;
  }
  const { type: benefitType } = benefitToApply;
  switch (benefitType) {
    case "PRODUCT":
      return applyProductBenefitHelper(reusedConfig, benefitToApply);
    case "ALTER_DELIVERY":
      return applyAlterDeliveryBenefitHelper(reusedConfig, benefitToApply);
    case "DISCOUNT_PERCENTAGE":
    case "DISCOUNT_FIXED":
      return applyDiscountBenefitHelper(reusedConfig, benefitToApply);
    default:
      logError("The benefit to be applied is not of type PRODUCT, DISCOUNT_PERCENTAGE, DISCOUNT_FIXED or ALTER_DELIVERY.");
      break;
  }
};
const applyProductBenefitHelper = async (config, benefit) => {
  const reusedConfig = reuseGlobalConfig(config);
  const { product, productConfig, anonymous } = reusedConfig;
  const { benefitId } = benefit;
  if (!product || !productConfig) {
    logError(`The product or the product configuration has not been provided to apply the selected benefit.`);
    return;
  }
  product.benefitId = benefitId;
  await applyBenefitsToCart(reusedConfig, benefit);
  await addProduct(product, __spreadValues$3({ anonymous }, productConfig));
};
const applyAlterDeliveryBenefitHelper = async (config, benefit) => {
  const reusedConfig = reuseGlobalConfig(config);
  const { shippingCost, latitude, longitude, shoppingCartName } = reusedConfig;
  const { anonymous } = reusedConfig;
  if (!shippingCost || !latitude || !longitude) {
    logError("The shippingCost, latitude and longitude are required to apply the selected benefit.");
    return;
  }
  const { benefitWalletId, award } = benefit;
  if (Array.isArray(award)) {
    logError("To apply a ALTER_DELIVERY benefit, the award associated with the benefit cannot be an array.");
    return;
  }
  const { benefitId: awardBenefitId, discountPercentage } = award;
  const { subtotalBeforeTaxes } = shippingCost;
  const value = subtotalBeforeTaxes * (discountPercentage / 100);
  const benefitList = [];
  benefitList.push({
    benefitWalletId,
    benefitId: awardBenefitId,
    discountBase: subtotalBeforeTaxes,
    percentage: discountPercentage,
    priceCategory: "NORMAL",
    value
  });
  shippingCost.discounts = benefitList;
  await applyBenefitsToCart(reusedConfig, benefit, shippingCost);
  await validateShoppingCart({
    latitude,
    longitude,
    shoppingCartName,
    anonymous
  });
};
const applyBenefitsToCart = async (config, benefit, shippingCost) => {
  const shoppingCartNode = await getShoppingCartNode(config);
  if (!shoppingCartNode) {
    console.warn("Cannot add benefit because no shopping cart nodes were found. Please ensure you have a shopping cart before continue.");
    return;
  }
  const shoppingCart = await shoppingCartNode.data();
  const updatedCart = applyBenefitsHelper(shoppingCart, benefit, shippingCost);
  await shoppingCartNode.ref.set(updatedCart);
};
const applyBenefitsHelper = (shoppingCart, benefit, shippingCost) => {
  const { hash } = benefit;
  const { benefits } = shoppingCart;
  const temporalBenefits = benefits != null ? benefits : [];
  temporalBenefits.push(benefit);
  shoppingCart.benefits = temporalBenefits;
  shoppingCart.benefitsHash = hash;
  if (shippingCost)
    shoppingCart.shippingCost = shippingCost;
  return shoppingCart;
};
const applyDiscountBenefitHelper = async (config, benefit) => {
  const reuseConfig = reuseGlobalConfig(config);
  const { customerId, shoppingCartId, shoppingCartName } = reuseConfig;
  if (!customerId) {
    logError("To apply a DISCOUNT_PERCENTAGE or DISCOUNT_FIXED benefit, a customerId must be provided.");
    return;
  }
  if (!shoppingCartId) {
    logError("To apply a DISCOUNT_PERCENTAGE or DISCOUNT_FIXED benefit, a shoppingCartId must be provided.");
    return;
  }
  const shoppingCart = await getShoppingCart(reuseConfig);
  if (!shoppingCart) {
    logError(`Cannot apply discount benefit because no shopping cart was found. Please ensure you create a shopping cart with name ${shoppingCartName} before continue.`);
    return;
  }
  const { subtotal } = getShoppingCartTotal(shoppingCart);
  if (benefit.type === "DISCOUNT_FIXED" && subtotal < Number(benefit.discountFixed)) {
    logError("Cannot apply DISCOUNT_FIXED benefit because discount is greater than cart subtotal.");
    return;
  }
  await applyBenefitService({ benefit, customerId, shoppingCartId });
};

var __defProp$2 = Object.defineProperty;
var __defProps$1 = Object.defineProperties;
var __getOwnPropDescs$1 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2 = (obj, key, value) => key in obj ? __defProp$2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2.call(b, prop))
      __defNormalProp$2(a, prop, b[prop]);
  if (__getOwnPropSymbols$2)
    for (var prop of __getOwnPropSymbols$2(b)) {
      if (__propIsEnum$2.call(b, prop))
        __defNormalProp$2(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1 = (a, b) => __defProps$1(a, __getOwnPropDescs$1(b));
const removeBenefit = async (config) => {
  const reusedConfig = reuseGlobalConfig(config);
  checkMinimumConfigProvided(reusedConfig);
  const { benefitId, shoppingCartName } = reusedConfig;
  const { wallets } = getState();
  const errorMessage = checkBenefitConfigProvided(wallets, shoppingCartName, reusedConfig);
  if (errorMessage) {
    logError(errorMessage);
    return;
  }
  const activeWallet = wallets[shoppingCartName];
  const benefits = activeWallet.benefits;
  const benefitToRemove = benefits.find((benefit) => benefit.benefitId === benefitId);
  if (!benefitToRemove) {
    logError(`No benefit was found in the benefits wallet with the benefitId provided.`);
    return;
  }
  const { type: benefitType } = benefitToRemove;
  switch (benefitType) {
    case "PRODUCT":
      return removeProductBenefitHelper(reusedConfig, benefitToRemove);
    case "ALTER_DELIVERY":
      return removeAlterDeliveryBenefitHelper(reusedConfig, benefitToRemove);
    case "DISCOUNT_PERCENTAGE":
    case "DISCOUNT_FIXED":
      return removeBenefitsFromCart(reusedConfig, benefitToRemove);
    default:
      logError("The benefit to be removed is not of type PRODUCT, DISCOUNT_PERCENTAGE, DISCOUNT_FIXED or ALTER_DELIVERY.");
      break;
  }
};
const removeProductBenefitHelper = async (config, benefit) => {
  const reusedConfig = reuseGlobalConfig(config);
  const { product, productConfig } = reusedConfig;
  const { store } = productConfig != null ? productConfig : {};
  if (!product || !store) {
    logError("The cart product and the store, inside benefitProductConfig object, are required to remove the selected benefit.");
    return;
  }
  reusedConfig.productConfig.store = __spreadProps$1(__spreadValues$2({}, store), { polygons: null });
  await removeBenefitsFromCart(reusedConfig, benefit);
  await removeProduct(product, productConfig);
};
const removeAlterDeliveryBenefitHelper = async (config, benefit) => {
  const reusedConfig = reuseGlobalConfig(config);
  const { shippingCost } = reusedConfig;
  if (!shippingCost) {
    logError(`The shippingCost is require to remove the selected benefit.`);
    return;
  }
  return removeBenefitsFromCart(reusedConfig, benefit, shippingCost);
};
const removeBenefitsFromCart = async (config, benefit, shippingCost) => {
  const shoppingCartNode = await getShoppingCartNode(config);
  if (!shoppingCartNode) {
    console.warn(`Cannot remove benefit because no shopping cart nodes were found. Please ensure you have a shopping cart before continue.`);
    return;
  }
  const shoppingCart = await shoppingCartNode.data();
  const updatedCart = removeBenefitsHelper(shoppingCart, benefit, shippingCost);
  await shoppingCartNode.ref.set(updatedCart);
};
const removeBenefitsHelper = (shoppingCart, benefit, shippingCost) => {
  const { benefits } = shoppingCart;
  const { benefitId } = benefit;
  if (!benefits) {
    console.warn(`Cannot remove benefit because the shopping cart does not have benefits applied.`);
    return shoppingCart;
  }
  const benefitIdIndex = benefits.findIndex((benefit2) => benefit2.benefitId === benefitId);
  if (benefitIdIndex < 0) {
    console.warn(`This benefit cannot be removed because it is not applied to the shopping cart.`);
    return shoppingCart;
  }
  benefits.splice(benefitIdIndex, 1);
  delete shoppingCart.benefitsHash;
  if (shippingCost)
    shoppingCart.shippingCost = shippingCost;
  return shoppingCart;
};

var __defProp$1 = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(b)) {
      if (__propIsEnum$1.call(b, prop))
        __defNormalProp$1(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const redeemCoupon = async (config, code, headers) => {
  const reusedConfig = reuseGlobalConfig(config);
  const { customerId, shoppingCartName } = reusedConfig;
  checkMinimumConfigProvided(config);
  checkCommonHeaders(headers);
  const { wallets } = getState();
  const activeWallet = wallets[shoppingCartName];
  if (!activeWallet) {
    logError(`No benefits wallet available for ${shoppingCartName}, you probably forgot to call listenBenefitsWallet beforehand.`);
  }
  await redeemCouponService(reusedConfig, code, headers);
  await fetchWalletByUser(reusedConfig, headers);
  const benefits = await getWallet({
    customerId,
    shoppingCartName
  });
  if (!benefits) {
    throw new Error(`Failed to fetch benefits from firestore for the current customer after redeeming coupon`);
  }
  const updatedWallet = getInitialBenefitsWallet({
    benefits
  });
  const newInternalWallet = {
    benefits: [...updatedWallet.benefits],
    onSnapshot: activeWallet.onSnapshot
  };
  const newWallets = __spreadProps(__spreadValues$1({}, wallets), {
    [shoppingCartName]: newInternalWallet
  });
  setState({ wallets: newWallets });
  activeWallet.onSnapshot(updatedWallet);
};

const mergeShoppingCart = async (shoppingCart, config) => {
  return new Promise((resolve, reject) => {
    const action = async () => {
      try {
        const shoppingCartNode = await getShoppingCartNode(config);
        if (!shoppingCartNode) {
          logDebug("Cannot merge the shopping carts because no shopping cart nodes were found. Please ensure you have a shopping cart before continue.");
          resolve(null);
          return null;
        }
        let destinyShoppingCart = shoppingCartNode.data();
        const stores = Object.values(shoppingCart.stores);
        stores.forEach((store, index) => {
          const products = Object.values(store.products);
          products.forEach((product) => {
            const { amount } = product;
            destinyShoppingCart = addProductToCartHelper(destinyShoppingCart, product, {
              store,
              amount
            });
          });
        });
        await shoppingCartNode.ref.set(destinyShoppingCart);
        resolve(destinyShoppingCart);
        return destinyShoppingCart;
      } catch (e) {
        reject(e);
        return null;
      }
    };
    const { eventLoop, queue } = getState();
    queue.enqueue(action);
    if (!eventLoop.isRunning)
      eventLoop.start();
  });
};

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const updateShoppingCart = async (setShoppingCart, config) => {
  return new Promise((resolve, reject) => {
    const action = async () => {
      try {
        const { shoppingCartName } = reuseGlobalConfig(config);
        const shoppingCartNode = await getShoppingCartNode(config);
        if (!shoppingCartNode) {
          console.warn(`Cannot update remote cart because no shopping cart was found. Please ensure you create a shopping cart with name ${shoppingCartName} before continue.`);
          resolve(null);
          return null;
        }
        const cart = await shoppingCartNode.data();
        const updatedCart = updateShoppingCartHelper(cart, setShoppingCart);
        await shoppingCartNode.ref.set(updatedCart);
        resolve(updatedCart);
        return updatedCart;
      } catch (e) {
        reject(e);
        return null;
      }
    };
    const { eventLoop, queue } = getState();
    queue.enqueue(action);
    if (!eventLoop.isRunning)
      eventLoop.start();
  });
};
const updateShoppingCartHelper = (cart, setShoppingCart) => {
  const updatedCart = __spreadValues(__spreadValues({}, cart), setShoppingCart(cart));
  return updatedCart;
};

export { addProduct, applyBenefit, checkInit, closeShoppingCart, createShoppingCart, deleteShoppingCart, emptyShoppingCart, fetchStoreCouponDetail, fetchStoreCoupons, findProduct, getProductHash, getShoppingCart, getShoppingCartProducts, getShoppingCartTotal, initShoppingCart, listenBenefitsWallet, listenShoppingCart, mergeShoppingCart, redeemCoupon, removeBenefit, removeProduct, replaceProduct, setProduct, subtractProduct, updateShoppingCart, validateShoppingCart };
//# sourceMappingURL=bundle.esm.js.map
